'use strict';
/* ═══════════════════════════════════════════════════════
   SR CHAMPIONS — Panel de Administración v2
   Soccer Revolution · Champions League 2026/27
═══════════════════════════════════════════════════════ */

function chaEsc(str) {
  return String(str == null ? '' : str)
    .replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":"&#39;"}[c]));
}

const CH_ADMIN_EMAIL = 'soccerrevolution.gt21@gmail.com';

const CH_ADMIN_FIREBASE = {
  apiKey: "AIzaSyDdl5WQHtTN2wTMOvLKFWLgJBXZ9Xbz-7c",
  authDomain: "soccer-revolution-champions.firebaseapp.com",
  projectId: "soccer-revolution-champions",
  storageBucket: "soccer-revolution-champions.firebasestorage.app",
  messagingSenderId: "553292595830",
  appId: "1:553292595830:web:44fdb13c783db206fb9557"
};

const CHAdmin = {

  db: null, auth: null,
  _currentPhase: 'league', _currentPhaseResult: 'league',
  _currentJornada: 1, _currentResultJornada: 1,
  _activeTab: 'fases',
  _prizeLevels: [],

  FASES_ELIM: [
    { id: 'playoff', nombre: 'PLAYOFF',       ties: 8, legs: 2, icono: '⚡', pts: { resultado:4,  exacto:10, anotador:3  } },
    { id: 'r16',     nombre: '8VOS DE FINAL', ties: 8, legs: 2, icono: '⚽', pts: { resultado:6,  exacto:15, anotador:4  } },
    { id: 'qf',      nombre: 'CUARTOS',       ties: 4, legs: 2, icono: '🔥', pts: { resultado:10, exacto:22, anotador:5  } },
    { id: 'sf',      nombre: 'SEMIFINALES',   ties: 2, legs: 2, icono: '💥', pts: { resultado:15, exacto:32, anotador:8  } },
    { id: 'final',   nombre: 'GRAN FINAL',    ties: 1, legs: 1, icono: '🏆', pts: { resultado:22, exacto:60, anotador:10 } }
  ],
  LIGA_PTS: { resultado:2, exacto:7, anotador:2 },
  RACHAS:   [{ n:3, bonus:5 }, { n:5, bonus:15 }, { n:8, bonus:35 }, { n:12, bonus:70 }],

  // Combina config/points (si el admin ya personalizó los valores) con los
  // valores por defecto de arriba — config parcial es seguro: cualquier fase
  // que falte en el doc cae en su valor por defecto individual.
  _resolvePoints(points) {
    const map = {};
    this.FASES_ELIM.forEach(f => { map[f.id] = Object.assign({}, f.pts, (points && points[f.id]) || {}); });
    map.league = Object.assign({}, this.LIGA_PTS, (points && points.league) || {});
    return map;
  },
  _resolveRacha(points) {
    return (points && Array.isArray(points.racha) && points.racha.length) ? points.racha : this.RACHAS;
  },

  /* ── Init ──────────────────────────────────────────── */
  async init() {
    await new Promise(res => {
      const chk = () => (typeof firebase !== 'undefined' && firebase.firestore) ? res() : setTimeout(chk, 50);
      chk();
    });
    const existing = firebase.apps.find(a => a.name === 'champions-admin');
    const app = existing || firebase.initializeApp(CH_ADMIN_FIREBASE, 'champions-admin');
    this.db   = firebase.firestore(app);
    this.auth = firebase.auth(app);

    this.auth.onAuthStateChanged(user => {
      if (user && user.email === CH_ADMIN_EMAIL) {
        this.showPanel();
      } else {
        if (user) this.auth.signOut();
        this.showLogin();
      }
    });

    document.addEventListener('click', e => {
      if (!e.target.closest('.ca-search-wrap')) {
        const r = document.getElementById('cha-search-results');
        if (r) r.classList.remove('open');
      }
    });
  },

  /* ── Auth ──────────────────────────────────────────── */
  async login(e) {
    e.preventDefault();
    const pass = document.getElementById('cha-pass')?.value || '';
    const btn  = document.getElementById('cha-login-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Entrando...'; }
    try {
      await this.auth.signInWithEmailAndPassword(CH_ADMIN_EMAIL, pass);
    } catch(err) {
      this.toast('Contraseña incorrecta', 'error');
      if (btn) { btn.disabled = false; btn.textContent = 'ENTRAR AL PANEL'; }
    }
  },

  logout() { this.auth.signOut(); },

  showLogin() {
    const login = document.getElementById('cha-login');
    const panel = document.getElementById('cha-panel');
    if (login) { login.style.display = 'flex'; }
    if (panel) { panel.style.display = 'none'; }
  },

  showPanel() {
    const login = document.getElementById('cha-login');
    const panel = document.getElementById('cha-panel');
    if (login) { login.style.display = 'none'; }
    if (panel) { panel.style.display = 'block'; }
    this.renderStats();
    this.switchTab('fases');
  },

  /* ── Utils ─────────────────────────────────────────── */
  toast(msg, type = 'info', ms = 4000) {
    const wrap = document.getElementById('cha-notif');
    if (!wrap) return;
    const el = document.createElement('div');
    el.className = 'cha-notif-item' + (type !== 'info' ? ' ' + type : '');
    el.textContent = msg;
    wrap.appendChild(el);
    setTimeout(() => el.remove(), ms);
  },

  toLocalInputValue(iso) {
    if (!iso) return '';
    try {
      const d = new Date(iso);
      if (isNaN(d)) return '';
      const pad = n => String(n).padStart(2, '0');
      return d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()) +
        'T' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    } catch { return ''; }
  },

  isSessionError(err) {
    const c = err && err.code;
    return c === 'permission-denied' || c === 'unauthenticated' ||
      c === 'auth/user-token-expired' || c === 'auth/user-disabled';
  },

  handleSessionErr() {
    this.auth.signOut();
    this.toast('Sesión expirada. Volvé a iniciar sesión.', 'error');
    this.showLogin();
  },

  /* ── Buscador único (usuarios + partidos) ──────────────
     Cachea usuarios y partidos una sola vez por sesión de admin y filtra en el
     cliente en cada tecla — evita golpear Firestore en cada letra tipeada. La
     caché se recarga sola la próxima vez que se abre el panel (F5). ── */
  async _ensureSearchCache() {
    if (this._searchCache) return this._searchCache;
    const [usersSnap, matchesSnap] = await Promise.all([
      this.db.collection('users').get(),
      this.db.collection('matches').get()
    ]);
    const users = [];
    usersSnap.forEach(d => users.push({ id: d.id, ...d.data() }));
    const matches = [];
    matchesSnap.forEach(d => { if (d.id !== 'test_match') matches.push({ id: d.id, ...d.data() }); });
    this._searchCache = { users, matches };
    return this._searchCache;
  },

  async universalSearch(query) {
    const resultsEl = document.getElementById('cha-search-results');
    if (!resultsEl) return;
    const q = query.trim().toLowerCase();
    if (!q) { resultsEl.innerHTML = ''; resultsEl.classList.remove('open'); return; }
    resultsEl.classList.add('open');
    resultsEl.innerHTML = '<div class="ca-search-loading">Buscando...</div>';

    let cache;
    try {
      cache = await this._ensureSearchCache();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      resultsEl.innerHTML = '<div class="ca-search-empty">Error al buscar.</div>';
      return;
    }
    // Si el usuario siguió tipeando mientras cargaba, no pisar un resultado más nuevo
    const searchInput = document.getElementById('cha-search');
    if (searchInput && searchInput.value.trim().toLowerCase() !== q) return;

    const userMatches = cache.users.filter(u =>
      (u.displayName || '').toLowerCase().includes(q) ||
      (u.username || '').toLowerCase().includes(q) ||
      (u.email || '').toLowerCase().includes(q)
    ).slice(0, 6);

    const matchMatches = cache.matches.filter(m =>
      (m.homeTeamName || '').toLowerCase().includes(q) ||
      (m.awayTeamName || '').toLowerCase().includes(q) ||
      (m.venue || '').toLowerCase().includes(q)
    ).slice(0, 6);

    if (userMatches.length === 0 && matchMatches.length === 0) {
      resultsEl.innerHTML = '<div class="ca-search-empty">Sin resultados para "' + chaEsc(query) + '"</div>';
      return;
    }

    let html = '';
    if (userMatches.length > 0) {
      html += '<div class="ca-search-group-label">👤 Usuarios</div>' +
        userMatches.map(u => '<div class="ca-search-item" onclick="CHAdmin.goToSearchResult(\'user\',\'' + u.id + '\')">' +
          '<strong>' + chaEsc(u.displayName || '?') + '</strong>' +
          (u.username ? ' <span>@' + chaEsc(u.username) + '</span>' : '') +
        '</div>').join('');
    }
    if (matchMatches.length > 0) {
      const phLbl = { league: 'Liga', playoff: 'Playoff', r16: '8vos', qf: 'Cuartos', sf: 'Semis', final: 'Final' };
      html += '<div class="ca-search-group-label">⚽ Partidos</div>' +
        matchMatches.map(m => '<div class="ca-search-item" onclick="CHAdmin.goToSearchResult(\'match\',\'' + m.id + '\')">' +
          '<strong>' + chaEsc(m.homeTeamName || '?') + ' vs ' + chaEsc(m.awayTeamName || '?') + '</strong>' +
          ' <span>' + (m.phase === 'league' ? 'Jornada ' + (m.matchday || '?') : chaEsc(phLbl[m.phase] || m.phase || '')) + '</span>' +
        '</div>').join('');
    }
    resultsEl.innerHTML = html;
  },

  async goToSearchResult(type, id) {
    const resultsEl = document.getElementById('cha-search-results');
    const searchInput = document.getElementById('cha-search');
    if (resultsEl) { resultsEl.innerHTML = ''; resultsEl.classList.remove('open'); }
    if (searchInput) searchInput.value = '';
    const cache = this._searchCache;
    if (!cache) return;

    if (type === 'user') {
      await this.switchTab('usuarios');
      const u = cache.users.find(x => x.id === id);
      const search = document.getElementById('cha-user-search');
      if (search && u) {
        search.value = u.username || u.displayName || '';
        this._filterUsers(search.value);
      }
    } else if (type === 'match') {
      const m = cache.matches.find(x => x.id === id);
      if (!m) return;
      this._currentPhase = m.phase === 'league' ? 'league' : m.phase;
      if (m.phase === 'league') this._currentJornada = m.matchday || 1;
      document.querySelectorAll('#cha-phase-tabs .cha-sub-tab').forEach(b => b.classList.toggle('active', b.dataset.phase === this._currentPhase));
      this.switchTab('partidos');
    }
  },

  statusBadge(status) {
    const map = {
      pending_teams: '<span class="cha-badge cha-badge-pending_teams">Por definir</span>',
      scheduled:     '<span class="cha-badge cha-badge-pending">Programado</span>',
      open:          '<span class="cha-badge cha-badge-open">Abierto</span>',
      locked:        '<span class="cha-badge cha-badge-locked">Cerrado</span>',
      live:          '<span class="cha-badge cha-badge-open">En vivo</span>',
      finished:      '<span class="cha-badge cha-badge-finished">Finalizado</span>',
      postponed:     '<span class="cha-badge cha-badge-locked">Postergado</span>',
      cancelled:     '<span class="cha-badge cha-badge-locked">Cancelado</span>'
    };
    return map[status] || '<span class="cha-badge cha-badge-pending">' + chaEsc(status || '—') + '</span>';
  },

  /* ── Stats bar ─────────────────────────────────────── */
  async renderStats() {
    try {
      const [matchSnap, userSnap, resultSnap, cfgSnap] = await Promise.all([
        this.db.collection('matches').get(),
        this.db.collection('users').get(),
        this.db.collection('results').get(),
        this.db.doc('config/main').get()
      ]);
      const cfg = cfgSnap.exists ? cfgSnap.data() : {};
      const jornadas = (cfg.jornadasActivas || []).length;
      const fases    = (cfg.fasesActivas    || []).length;

      // Header stat bar (tablet/mobile — horizontal chips)
      const bar = document.getElementById('cha-stat-bar');
      if (bar) bar.innerHTML =
        '<span class="ca-stat-chip">⚽ <strong>' + matchSnap.size + '</strong> partidos</span>' +
        '<span class="ca-stat-chip">👥 <strong>' + userSnap.size  + '</strong> usuarios</span>' +
        '<span class="ca-stat-chip">✅ <strong>' + resultSnap.size + '</strong> resultados</span>';

      // Sidebar stat bar (desktop — vertical)
      const barD = document.getElementById('cha-stat-bar-desktop');
      if (barD) barD.innerHTML =
        '<div class="ca-kpi"><div class="ca-kpi-label">Partidos</div><div class="ca-kpi-value">' + matchSnap.size  + '</div></div>' +
        '<div class="ca-kpi"><div class="ca-kpi-label">Usuarios</div><div class="ca-kpi-value">' + userSnap.size   + '</div></div>' +
        '<div class="ca-kpi"><div class="ca-kpi-label">Resultados</div><div class="ca-kpi-value">' + resultSnap.size + '</div></div>' +
        '<div class="ca-kpi"><div class="ca-kpi-label">Jornadas activas</div><div class="ca-kpi-value">' + jornadas + '<span style="font-size:14px;color:var(--ca-muted)">/8</span></div></div>' +
        '<div class="ca-kpi"><div class="ca-kpi-label">Fases elim. activas</div><div class="ca-kpi-value">' + fases + '<span style="font-size:14px;color:var(--ca-muted)">/5</span></div></div>';
    } catch(e) { /* non-critical */ }
  },

  /* ── Tabs ──────────────────────────────────────────── */
  switchTab(tab) {
    this._activeTab = tab;

    // Activate nav items across all 3 nav sources
    const allNavBtns = document.querySelectorAll(
      '.ca-nav-item, .ca-tab-strip-btn, .ca-bottom-btn'
    );
    allNavBtns.forEach(b => b.classList.toggle('active', b.dataset.tab === tab));

    // Show/hide content panels
    document.querySelectorAll('.ca-tab-body').forEach(b => {
      b.classList.toggle('active', b.dataset.tab === tab);
    });

    // Render content
    const renders = {
      fases:          () => this.renderFases(),
      partidos:       () => this.renderPartidos(),
      resultados:     () => this.renderResultados(),
      puntos:         () => this.renderPuntos(),
      usuarios:       () => this.renderUsuarios(),
      premios:        () => this.renderPremios(),
      patrocinadores: () => this.renderPatrocinadores(),
      banners:        () => this.renderBanners(),
      analiticas:     () => this.renderAnaliticas(),
      fama:           () => this.renderFama()
    };
    return renders[tab] ? renders[tab]() : undefined;
  },

  /* ══════════════════════════════════════════════════
     TAB: FASES
  ══════════════════════════════════════════════════ */
  /* ── Anuncio para todos los usuarios (banner en el Dashboard) ──
     Se guarda dentro del mismo doc config/main (campo "announcement") para no
     sumar una lectura extra en _loadConfig() del lado del usuario. ── */
  async renderAnuncio() {
    const cont = document.getElementById('cha-anuncio-content');
    if (!cont) return;
    try {
      const snap = await this.db.doc('config/main').get();
      const ann = (snap.exists && snap.data().announcement) || {};
      cont.innerHTML =
        '<div class="cha-card" style="margin-bottom:20px;border-color:rgba(0,207,255,.25)">' +
          '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:12px;flex-wrap:wrap">' +
            '<div style="font-size:13px;font-weight:700;color:var(--ca-text)">📣 Anuncio para todos los usuarios</div>' +
            '<label style="display:flex;align-items:center;gap:8px;font-size:12px;color:var(--ca-muted);cursor:pointer">' +
              '<input type="checkbox" id="cha-ann-active"' + (ann.active ? ' checked' : '') + '> Activo' +
            '</label>' +
          '</div>' +
          '<textarea id="cha-ann-text" class="cha-input" rows="2" maxlength="160" ' +
            'placeholder="Ej: ¡Arrancó la Jornada 3! Ya podés cargar tus predicciones." ' +
            'style="width:100%;resize:vertical;margin-bottom:10px">' + chaEsc(ann.text || '') + '</textarea>' +
          '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px">' +
            '<span style="font-size:11px;color:var(--ca-muted)">Aparece como una franja arriba del Dashboard de todos los usuarios. Máx. 160 caracteres.</span>' +
            '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.saveAnuncio()" style="white-space:nowrap">💾 Guardar</button>' +
          '</div>' +
        '</div>';
    } catch(e) {
      cont.innerHTML = '';
    }
  },

  async saveAnuncio() {
    const text = (document.getElementById('cha-ann-text')?.value || '').trim().slice(0, 160);
    const active = !!document.getElementById('cha-ann-active')?.checked;
    try {
      await this.db.doc('config/main').set({
        announcement: { text, active, updatedAt: firebase.firestore.FieldValue.serverTimestamp() }
      }, { merge: true });
      this.toast(active && text ? '📣 Anuncio publicado' : '✅ Guardado', 'success');
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar el anuncio', 'error');
    }
  },

  /* ── Vista previa del Dashboard: "usuario nuevo" o "modo fantasma" ──
     Reconstruye una versión fiel (no interactiva) del Dashboard real usando
     las mismas clases de sr-champions.css (ya cargado en esta página), con
     datos leídos con el propio acceso de admin — no hace falta crear una
     cuenta de prueba ni loguearse como otro usuario. ── */
  async openDashboardPreview() {
    const existing = document.getElementById('cha-dash-preview-modal');
    if (existing) existing.remove();

    let cache;
    try { cache = await this._ensureSearchCache(); }
    catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      cache = { users: [] };
    }
    const userOptions = cache.users
      .filter(u => u.displayName || u.username)
      .sort((a, b) => (a.displayName || '').localeCompare(b.displayName || ''))
      .map(u => '<option value="' + u.id + '">' + chaEsc(u.displayName || u.username) + (u.username ? ' (@' + chaEsc(u.username) + ')' : '') + '</option>')
      .join('');

    const overlay = document.createElement('div');
    overlay.id = 'cha-dash-preview-modal';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(5,6,10,.9);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px';
    overlay.innerHTML =
      '<div style="background:#0b0d12;border:1px solid rgba(255,255,255,.15);border-radius:16px;max-width:460px;width:100%;max-height:92vh;overflow-y:auto;display:flex;flex-direction:column">' +
        '<div style="display:flex;justify-content:space-between;align-items:center;padding:18px 20px;border-bottom:1px solid rgba(255,255,255,.08);position:sticky;top:0;background:#0b0d12;z-index:1">' +
          '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:16px;letter-spacing:1px;color:#FF1464">👁️ Vista previa del Dashboard</span>' +
          '<button onclick="document.getElementById(\'cha-dash-preview-modal\').remove()" style="background:none;border:none;color:#9aaabf;font-size:18px;cursor:pointer;line-height:1">✕</button>' +
        '</div>' +
        '<div style="padding:14px 20px;border-bottom:1px solid rgba(255,255,255,.08);display:flex;gap:8px;flex-wrap:wrap">' +
          '<select id="cha-dash-preview-mode" class="cha-input" style="flex:1;min-width:150px" onchange="CHAdmin._onDashPreviewModeChange()">' +
            '<option value="new">✨ Usuario nuevo (recién registrado)</option>' +
            '<option value="user">🕵️ Modo fantasma — ver como…</option>' +
          '</select>' +
          '<select id="cha-dash-preview-user" class="cha-input" style="flex:1;min-width:150px;display:none" onchange="CHAdmin.renderDashboardPreview()">' +
            '<option value="">Elegí un participante…</option>' + userOptions +
          '</select>' +
        '</div>' +
        '<div id="cha-dash-preview-body" style="padding:18px 20px"></div>' +
      '</div>';
    overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });
    document.body.appendChild(overlay);
    this.renderDashboardPreview();
  },

  _onDashPreviewModeChange() {
    const mode = document.getElementById('cha-dash-preview-mode')?.value;
    const userSel = document.getElementById('cha-dash-preview-user');
    if (userSel) userSel.style.display = mode === 'user' ? '' : 'none';
    this.renderDashboardPreview();
  },

  async renderDashboardPreview() {
    const body = document.getElementById('cha-dash-preview-body');
    if (!body) return;
    const mode = document.getElementById('cha-dash-preview-mode')?.value || 'new';
    const uid = document.getElementById('cha-dash-preview-user')?.value || '';

    if (mode === 'user' && !uid) {
      body.innerHTML = '<div style="color:var(--ca-muted);text-align:center;padding:30px;font-size:13px">Elegí un participante arriba.</div>';
      return;
    }
    body.innerHTML = '<div style="color:var(--ca-muted);text-align:center;padding:30px;font-size:13px">Cargando...</div>';

    try {
      let name = 'Nuevo Participante', pts = 0;
      if (mode === 'user') {
        const [userSnap, profSnap] = await Promise.all([
          this.db.doc('users/' + uid).get(),
          this.db.doc('users/' + uid + '/ch_profile/main').get()
        ]);
        const base = userSnap.exists ? userSnap.data() : {};
        const prof = profSnap.exists ? profSnap.data() : {};
        name = prof.displayName || base.displayName || 'Participante';
        pts = prof.totalPoints || 0;
      }

      const [cfgSnap, prizesSnap, sponsorsSnap, bannersSnap] = await Promise.all([
        this.db.doc('config/main').get(),
        this.db.doc('config/prizes').get(),
        this.db.collection('champions_sponsors').get(),
        this.db.collection('champions_banners').get()
      ]);
      const cfg = cfgSnap.exists ? cfgSnap.data() : {};
      const prizes = (prizesSnap.exists && Array.isArray(prizesSnap.data().levels) && prizesSnap.data().levels.length > 0)
        ? prizesSnap.data().levels.slice().sort((a, b) => (a.pts || 0) - (b.pts || 0))
        : [100, 280, 550, 900, 1400].map((p, i) => ({ pts: p, title: ['5% descuento', '10% descuento', '15% descuento', '20% + accesorio', 'Camisola Champions'][i], icon: '🏆' }));

      const now = new Date();
      const isLive = b => b.active !== false &&
        (!b.startAt || new Date(b.startAt) <= now) &&
        (!b.endAt || new Date(b.endAt) > now);
      const liveBanners = [];
      bannersSnap.forEach(d => { const b = d.data(); if (isLive(b)) liveBanners.push(b); });
      liveBanners.sort((a, b) => (a.order || 0) - (b.order || 0));

      const sponsors = [];
      sponsorsSnap.forEach(d => sponsors.push({ id: d.id, ...d.data() }));
      const sponsorTitle = sponsors.find(s => s.tier === 'title' && s.active !== false);
      const sponsorBanners = sponsors.filter(s => s.tier === 'banner' && s.active !== false).sort((a, b) => (a.order || 0) - (b.order || 0));

      const level = prizes.filter(p => pts >= (p.pts || 0)).pop();
      const init = (name || '?').charAt(0).toUpperCase();

      let html = '';

      if (cfg.announcement && cfg.announcement.active && cfg.announcement.text) {
        html += '<div class="sr-ch-announcement-banner"><span class="sr-ch-announcement-icon">📣</span><span class="sr-ch-announcement-text">' + chaEsc(cfg.announcement.text) + '</span></div>';
      }

      html += '<div class="sr-ch-dash-hero" style="margin-bottom:16px">' +
        '<div class="sr-ch-dash-avatar">' + chaEsc(init) + '</div>' +
        '<div class="sr-ch-dash-info">' +
          '<div class="sr-ch-dash-greeting">👋 Hola</div>' +
          '<div class="sr-ch-dash-name">' + chaEsc((name || '').toUpperCase()) + '</div>' +
          '<div class="sr-ch-dash-level">' + (level ? chaEsc(level.icon || '🏆') + ' ' + chaEsc(level.title || '') : '⚽ Empezá a ganar puntos') + '</div>' +
        '</div>' +
        '<div class="sr-ch-dash-pts-badge"><div class="sr-ch-dash-pts-num">' + pts + '</div><div class="sr-ch-dash-pts-lbl">PUNTOS</div></div>' +
      '</div>';

      if (liveBanners.length > 0) {
        const b = liveBanners[0];
        const bOverlay = (b.title || b.ctaText)
          ? '<div class="sr-ch-banner-overlay">' + (b.title ? '<div class="sr-ch-banner-title">' + chaEsc(b.title) + '</div>' : '') + (b.ctaText ? '<span class="sr-ch-banner-cta">' + chaEsc(b.ctaText) + '</span>' : '') + '</div>'
          : '';
        html += '<div class="sr-ch-banner-carousel" style="margin-bottom:16px"><div class="sr-ch-banner-track"><div class="sr-ch-banner-slide"><img class="sr-ch-banner-img" src="' + b.image + '">' + bOverlay + '</div></div></div>';
      } else {
        html += '<div class="sr-ch-banner-carousel sr-ch-banner-preview" style="margin-bottom:16px"><div class="sr-ch-banner-track"><div class="sr-ch-banner-slide sr-ch-banner-slide-placeholder"><div class="sr-ch-banner-overlay"><div class="sr-ch-banner-title sr-ch-sponsor-placeholder-text">TU BANNER AQUÍ</div><span class="sr-ch-banner-cta sr-ch-banner-cta-placeholder sr-ch-sponsor-placeholder-text">Espacio disponible</span></div></div></div></div>';
      }

      if (sponsorTitle) {
        const stInner = sponsorTitle.logo ? '<img class="sr-ch-sponsor-title-logo" src="' + sponsorTitle.logo + '">' : '<span class="sr-ch-sponsor-title-name">' + chaEsc(sponsorTitle.name || '') + '</span>';
        html += '<div class="sr-ch-sponsor-title" style="margin-bottom:16px"><span class="sr-ch-sponsor-title-label">PRESENTADO POR</span>' + stInner + '</div>';
      } else {
        html += '<div class="sr-ch-sponsor-title sr-ch-sponsor-preview" style="margin-bottom:16px"><span class="sr-ch-sponsor-title-label">PRESENTADO POR</span><span class="sr-ch-sponsor-title-name sr-ch-sponsor-placeholder-text">PATROCINADOR</span></div>';
      }

      if (sponsorBanners.length > 0) {
        html += '<div class="sr-ch-sponsor-strip" style="margin-bottom:16px"><div class="sr-ch-sponsor-page active">' +
          sponsorBanners.slice(0, 3).map(s => '<div class="sr-ch-sponsor-item">' + (s.logo ? '<img class="sr-ch-sponsor-item-logo" src="' + s.logo + '">' : '<span class="sr-ch-sponsor-item-name">' + chaEsc(s.name || '') + '</span>') + '</div>').join('') +
        '</div></div>';
      } else {
        html += '<div class="sr-ch-sponsor-strip sr-ch-sponsor-preview" style="margin-bottom:16px"><div class="sr-ch-sponsor-page active">' +
          [1, 2, 3].map(() => '<div class="sr-ch-sponsor-item"><span class="sr-ch-sponsor-item-name sr-ch-sponsor-placeholder-text">PATROCINADOR</span></div>').join('') +
        '</div></div>';
      }

      html += '<div class="cha-card">' +
        '<div style="font-size:10px;letter-spacing:1.5px;text-transform:uppercase;color:var(--ca-muted);margin-bottom:10px">🌡️ Termómetro de recompensas</div>' +
        prizes.map(p => {
          const reached = pts >= (p.pts || 0);
          return '<div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid rgba(255,255,255,.05);opacity:' + (reached ? 1 : .5) + '">' +
            '<span style="font-size:12px;color:#e8edf8">' + chaEsc(p.icon || '🏆') + ' ' + chaEsc(p.title || '') + '</span>' +
            '<span style="font-size:12px;color:#FF1464">' + (p.pts || 0) + ' pts' + (reached ? ' ✅' : '') + '</span>' +
          '</div>';
        }).join('') +
      '</div>';

      body.innerHTML = html;
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      body.innerHTML = '<div style="color:var(--ca-red);text-align:center;padding:20px;font-size:13px">Error al cargar la vista previa.</div>';
    }
  },

  async renderFases() {
    this.renderAnuncio();
    const cont = document.getElementById('cha-fases-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px">Cargando...</div>';
    try {
      const snap = await this.db.doc('config/main').get();
      const cfg  = snap.exists ? snap.data() : {};
      const jornadasActivas = cfg.jornadasActivas || [];
      const fasesActivas    = cfg.fasesActivas    || [];

      let html = '<div style="margin-bottom:28px">';
      html += '<div style="font-size:10px;letter-spacing:2px;color:var(--ca-muted);text-transform:uppercase;margin-bottom:12px;font-weight:700">LIGA — Jornadas 1 a 8</div>';
      html += '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(190px,1fr));gap:8px">';
      for (let j = 1; j <= 8; j++) {
        const on = jornadasActivas.includes(j);
        html += '<div class="ca-phase-card' + (on ? ' on' : '') + '">' +
          '<div>' +
            '<div class="ca-phase-card-label">Jornada ' + j + '</div>' +
            '<div class="ca-phase-card-pts" style="color:' + (on ? 'var(--ca-green)' : 'var(--ca-muted)') + '">' +
              (on ? '● Activa' : '○ Inactiva') +
            '</div>' +
          '</div>' +
          '<label class="ca-toggle">' +
            '<input type="checkbox"' + (on ? ' checked' : '') +
              ' onchange="CHAdmin.toggleJornada(' + j + ',this.checked)">' +
            '<span class="ca-toggle-slider"></span>' +
          '</label>' +
        '</div>';
      }
      html += '</div></div>';

      html += '<div>';
      html += '<div style="font-size:10px;letter-spacing:2px;color:var(--ca-muted);text-transform:uppercase;margin-bottom:12px;font-weight:700">ELIMINATORIAS</div>';
      html += '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:8px">';
      this.FASES_ELIM.forEach(f => {
        const on = fasesActivas.includes(f.id);
        html += '<div class="ca-phase-card' + (on ? ' on' : '') + '">' +
          '<div>' +
            '<div class="ca-phase-card-label">' + f.icono + ' ' + f.nombre + '</div>' +
            '<div class="ca-phase-card-pts">+' + f.pts.resultado + ' res · +' + f.pts.exacto + ' exacto · +' + f.pts.anotador + ' gol</div>' +
          '</div>' +
          '<label class="ca-toggle">' +
            '<input type="checkbox"' + (on ? ' checked' : '') +
              ' onchange="CHAdmin.toggleFaseElim(\'' + f.id + '\',this.checked)">' +
            '<span class="ca-toggle-slider"></span>' +
          '</label>' +
        '</div>';
      });
      html += '</div></div>';

      cont.innerHTML = html;
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      cont.innerHTML = '<div style="color:var(--ca-red);padding:20px">Error al cargar. Verificá tu conexión.</div>';
    }
  },

  async toggleJornada(j, enabled) {
    try {
      const snap = await this.db.doc('config/main').get();
      const cfg  = snap.exists ? snap.data() : {};
      let arr = (cfg.jornadasActivas || []).filter(n => n !== j);
      if (enabled) arr.push(j);
      arr.sort((a, b) => a - b);
      await this.db.doc('config/main').set({ jornadasActivas: arr }, { merge: true });
      this.toast('Jornada ' + j + (enabled ? ' activada ✅' : ' desactivada 🔒'), 'success');
      this.renderFases();
      this.renderStats();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar.', 'error');
    }
  },

  async toggleFaseElim(faseId, enabled) {
    try {
      const snap = await this.db.doc('config/main').get();
      const cfg  = snap.exists ? snap.data() : {};
      let arr = (cfg.fasesActivas || []).filter(f => f !== faseId);
      if (enabled) arr.push(faseId);
      await this.db.doc('config/main').set({ fasesActivas: arr }, { merge: true });
      const f = this.FASES_ELIM.find(x => x.id === faseId);
      this.toast((f ? f.nombre : faseId) + (enabled ? ' activada ✅' : ' desactivada 🔒'), 'success');
      this.renderFases();
      this.renderStats();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar.', 'error');
    }
  },

  /* ══════════════════════════════════════════════════
     TAB: PARTIDOS
  ══════════════════════════════════════════════════ */
  selectPhaseTab(phase) {
    this._currentPhase = phase;
    document.querySelectorAll('#cha-phase-tabs .cha-sub-tab').forEach(b => b.classList.toggle('active', b.dataset.phase === phase));
    this.renderPartidos();
  },

  async renderPartidos() {
    const cont = document.getElementById('cha-partidos-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px">Cargando...</div>';
    try {
      if (this._currentPhase === 'league') {
        await this._renderPartidosLiga(cont);
      } else if (this._currentPhase === 'test') {
        await this._renderPartidosPrueba(cont);
      } else {
        await this._renderPartidosElim(cont, this._currentPhase);
      }
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      console.error('[CHAdmin] renderPartidos:', e);
      cont.innerHTML = '<div style="color:var(--ca-red);padding:20px">Error: ' + chaEsc(e.message || e.code || 'desconocido') + '</div>';
    }
  },

  /* ── Partido de Prueba ─────────────────────────────── */
  async _renderPartidosPrueba(cont) {
    const TEST_ID = 'test_match';

    const snap = await this.db.doc('matches/' + TEST_ID).get();
    const exists = snap.exists;
    const m = exists ? snap.data() : null;

    // El puntaje/ranking real NUNCA se ve afectado por este partido (id fijo 'test_match'
    // excluido siempre en CHAdmin.recalcularPuntos) — esa parte del mensaje es una garantía
    // incondicional. La VISIBILIDAD para usuarios reales sí depende de dónde esté posicionado
    // (ver "MOVER" más abajo), así que el mensaje lo aclara cuando aplica.
    const isLive = exists && m.phase !== 'test';
    let html =
      '<div style="padding:14px 18px;background:rgba(251,146,60,.06);border:1px solid rgba(251,146,60,.2);border-radius:12px;margin-bottom:20px;display:flex;align-items:center;gap:12px">' +
        '<span style="font-size:20px">🧪</span>' +
        '<div>' +
          '<div style="font-size:13px;font-weight:600;color:#fb923c">Partido de Prueba</div>' +
          '<div style="font-size:11px;color:var(--ca-muted);margin-top:2px">ID: <code style="background:rgba(255,255,255,.05);padding:2px 6px;border-radius:4px;font-size:11px">test_match</code> · Nunca afecta el puntaje ni el ranking real, sin importar dónde esté posicionado.</div>' +
          (isLive
            ? '<div style="font-size:11px;color:#fb923c;margin-top:4px;font-weight:600">⚠️ Está posicionado fuera de "Oculto" — los usuarios reales pueden verlo y predecirlo ahora mismo.</div>'
            : '') +
        '</div>' +
      '</div>';

    if (!exists) {
      html +=
        '<div class="ca-empty">' +
          '<div class="ca-empty-icon">🧪</div>' +
          '<div style="margin-bottom:16px">No hay partido de prueba creado todavía.</div>' +
          '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.createTestMatch()">⚡ CREAR PARTIDO DE PRUEBA</button>' +
        '</div>';
    } else {
      // Compute position section vars
      const isElim = ['playoff','r16','qf','sf','final'].includes(m.phase);
      const _phLbl = { test:'🔒 Oculto', league:'⚽ Liga', playoff:'🎯 Playoff', r16:'🏆 Octavos', qf:'🏆 Cuartos', sf:'🏆 Semis', final:'🏆 Final' };
      const posMsg = m.phase === 'test'
        ? '🔒 Oculto para usuarios — visible solo desde el admin.'
        : m.phase === 'league'
          ? '👁 Visible en <strong style="color:var(--ca-gold)">Liga · Jornada ' + (m.matchday || '?') + '</strong> — los usuarios pueden vaticinar.'
          : '👁 Visible en <strong style="color:var(--ca-gold)">Eliminatorias · ' + (_phLbl[m.phase] || m.phase) + (m.leg ? ' — Leg ' + m.leg : '') + '</strong>.';
      const phaseOpts = Object.entries(_phLbl).map(([v,l]) =>
        '<option value="' + v + '"' + (m.phase === v ? ' selected' : '') + '>' + l + '</option>'
      ).join('');
      const mdOpts = [1,2,3,4,5,6,7,8].map(n =>
        '<option value="' + n + '"' + (m.matchday === n ? ' selected' : '') + '>Jornada ' + n + '</option>'
      ).join('');
      const posSection =
        '<div style="background:rgba(255,20,100,.04);border:1px solid rgba(255,20,100,.15);border-radius:10px;padding:14px 16px;margin-bottom:16px">' +
          '<div style="font-size:10px;letter-spacing:2px;color:var(--ca-gold);font-weight:700;text-transform:uppercase;margin-bottom:10px">📍 POSICIÓN EN EL TORNEO</div>' +
          '<div style="display:grid;grid-template-columns:1fr 1fr auto;gap:10px;align-items:end">' +
            '<div>' +
              '<label class="cha-label">Etapa</label>' +
              '<select id="tm-phase" class="cha-input" onchange="CHAdmin._tmPhaseChange()">' + phaseOpts + '</select>' +
            '</div>' +
            '<div id="tm-md-wrap"' + (m.phase !== 'league' ? ' style="display:none"' : '') + '>' +
              '<label class="cha-label">Jornada</label>' +
              '<select id="tm-md" class="cha-input">' + mdOpts + '</select>' +
            '</div>' +
            '<div id="tm-leg-wrap"' + (!isElim ? ' style="display:none"' : '') + '>' +
              '<label class="cha-label">Ida / Vuelta</label>' +
              '<select id="tm-leg" class="cha-input">' +
                '<option value="1"' + (m.leg !== 2 ? ' selected' : '') + '>Ida</option>' +
                '<option value="2"' + (m.leg === 2 ? ' selected' : '') + '>Vuelta</option>' +
              '</select>' +
            '</div>' +
            '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.applyTestPosition()" style="align-self:end;white-space:nowrap">⚡ MOVER</button>' +
          '</div>' +
          '<div style="margin-top:8px;font-size:11px;color:var(--ca-muted)">' + posMsg + '</div>' +
        '</div>';

      html += '<div class="cha-card" style="border-color:rgba(255,20,100,.25)">' +
        // Header
        '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:16px;flex-wrap:wrap">' +
          '<div>' +
            '<span class="cha-badge cha-badge-test">🧪 PARTIDO DE PRUEBA</span>' +
          '</div>' +
          '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">' +
            this.statusBadge(m.status || 'pending_teams') +
            '<select onchange="CHAdmin.saveMatchStatus(\'test_match\',this.value)" class="cha-input" style="font-size:11px;padding:5px 8px">' +
              ['pending_teams','scheduled','open','locked','live','finished'].map(s =>
                '<option value="' + s + '"' + (m.status === s ? ' selected' : '') + '>' + s + '</option>'
              ).join('') +
            '</select>' +
            '<button class="cha-btn cha-btn-sm" onclick="CHAdmin.resetTestMatch()" title="Vuelve a Real Madrid vs Manchester City, oculto, sin resultado">🔄 REINICIAR</button>' +
            '<button class="cha-btn cha-btn-danger cha-btn-sm" onclick="CHAdmin.deleteTestMatch()">🗑 ELIMINAR</button>' +
          '</div>' +
        '</div>' +
        posSection +
        // Teams
        '<div class="ca-match-teams-grid">' +
          '<div>' +
            '<label class="cha-label">Local</label>' +
            '<div class="ca-match-team-pair">' +
              '<input class="cha-input ca-match-team-flag" type="text" value="' + chaEsc(m.homeTeamFlag || '⚽') + '" maxlength="8" placeholder="🏴" id="hf-test_match">' +
              '<input class="cha-input" type="text" value="' + chaEsc(m.homeTeamName || '') + '" placeholder="Equipo local" id="hn-test_match" style="flex:1">' +
            '</div>' +
          '</div>' +
          '<div style="text-align:center;padding-top:22px;color:var(--ca-muted);font-family:\'Bebas Neue\',sans-serif;font-size:15px">VS</div>' +
          '<div>' +
            '<label class="cha-label">Visitante</label>' +
            '<div class="ca-match-team-pair">' +
              '<input class="cha-input ca-match-team-flag" type="text" value="' + chaEsc(m.awayTeamFlag || '⚽') + '" maxlength="8" placeholder="🏴" id="af-test_match">' +
              '<input class="cha-input" type="text" value="' + chaEsc(m.awayTeamName || '') + '" placeholder="Equipo visitante" id="an-test_match" style="flex:1">' +
            '</div>' +
          '</div>' +
        '</div>' +
        // Venue + Lock + Save
        '<div class="ca-match-meta-row">' +
          '<div>' +
            '<label class="cha-label">Estadio</label>' +
            '<input class="cha-input" type="text" value="' + chaEsc(m.venue || '') + '" placeholder="Estadio de prueba" id="ve-test_match" style="width:100%">' +
          '</div>' +
          '<div>' +
            '<label class="cha-label">🔒 Cierre de predicciones</label>' +
            '<input class="cha-input" type="datetime-local" value="' + this.toLocalInputValue(m.lockAt || '') + '" id="la-test_match" style="width:100%">' +
          '</div>' +
          '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.saveMatchData(\'test_match\')" style="align-self:end">💾 GUARDAR</button>' +
        '</div>';

      html += this._sponsorSection('test_match', m);

      html += '</div>';

      const resultData = await this.db.doc('results/test_match').get().then(s => s.exists ? s.data() : null).catch(() => null);
      html +=
        '<div style="margin-top:16px">' +
          '<div style="font-size:10px;letter-spacing:2px;color:var(--ca-muted);text-transform:uppercase;font-weight:700;margin-bottom:12px">RESULTADO DE PRUEBA</div>' +
          this._resultCard('test_match', m, resultData) +
        '</div>';
    }

    cont.innerHTML = html;
  },

  async createTestMatch() {
    try {
      await this.db.doc('matches/test_match').set({
        phase: 'test', matchday: 0, matchOrder: 0,
        homeTeamName: 'Real Madrid', homeTeamFlag: '🇪🇸',
        awayTeamName: 'Manchester City', awayTeamFlag: '🇬🇧',
        homeTeamId: 'real_madrid', awayTeamId: 'man_city',
        venue: 'Estadio de Prueba',
        lockAt: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString(),
        status: 'open',
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      }, { merge: true });
      this.toast('✅ Partido de prueba creado', 'success');
      this._renderPartidosPrueba(document.getElementById('cha-partidos-content'));
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al crear: ' + (e.message || e.code), 'error');
    }
  },

  async resetTestMatch() {
    if (!confirm('¿Reiniciar el partido de prueba a sus valores por defecto?\nVuelve a quedar oculto (fase "test"), sin resultado, con los equipos de ejemplo.')) return;
    try {
      const FVD = firebase.firestore.FieldValue.delete();
      await this.db.doc('matches/test_match').set({
        phase: 'test', matchday: 0, matchOrder: 0,
        tieId: FVD, leg: FVD,
        homeTeamName: 'Real Madrid', homeTeamFlag: '🇪🇸',
        awayTeamName: 'Manchester City', awayTeamFlag: '🇬🇧',
        homeTeamId: 'real_madrid', awayTeamId: 'man_city',
        venue: 'Estadio de Prueba',
        lockAt: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString(),
        status: 'open',
        sponsorName: FVD, sponsorLogo: FVD,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      }, { merge: true });
      await this.db.doc('results/test_match').delete().catch(() => {});
      this.toast('🔄 Partido de prueba reiniciado', 'success');
      this.renderStats();
      this._renderPartidosPrueba(document.getElementById('cha-partidos-content'));
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al reiniciar: ' + (e.message || e.code), 'error');
    }
  },

  async deleteTestMatch() {
    if (!confirm('¿Eliminar el partido de prueba y su resultado?\nEsta acción no se puede deshacer.')) return;
    try {
      await Promise.all([
        this.db.doc('matches/test_match').delete(),
        this.db.doc('results/test_match').delete().catch(() => {})
      ]);
      this.toast('🗑 Partido de prueba eliminado', 'success');
      this.renderStats();
      this._renderPartidosPrueba(document.getElementById('cha-partidos-content'));
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al eliminar: ' + (e.message || e.code), 'error');
    }
  },

  _tmPhaseChange() {
    const phase   = document.getElementById('tm-phase').value;
    const mdWrap  = document.getElementById('tm-md-wrap');
    const legWrap = document.getElementById('tm-leg-wrap');
    if (mdWrap)  mdWrap.style.display  = phase === 'league' ? '' : 'none';
    if (legWrap) legWrap.style.display = ['playoff','r16','qf','sf','final'].includes(phase) ? '' : 'none';
  },

  async applyTestPosition() {
    const phase = document.getElementById('tm-phase').value;
    const FVD   = firebase.firestore.FieldValue.delete();
    const update = { phase };
    let targetMatchday = null;

    if (phase === 'league') {
      targetMatchday    = parseInt(document.getElementById('tm-md').value, 10);
      update.matchday   = targetMatchday;
      update.matchOrder = 999;
      update.tieId      = FVD;
      update.leg        = FVD;
    } else if (['playoff','r16','qf','sf','final'].includes(phase)) {
      update.tieId      = 'test_tie01';
      update.leg        = parseInt(document.getElementById('tm-leg').value, 10);
      update.matchday   = FVD;
      update.matchOrder = FVD;
    } else {
      // 'test' = oculto
      update.tieId      = FVD;
      update.leg        = FVD;
      update.matchday   = FVD;
      update.matchOrder = FVD;
    }

    const label = { test:'modo oculto', league:'Liga · Jornada ' + (targetMatchday || '?'),
      playoff:'Playoff', r16:'Octavos', qf:'Cuartos', sf:'Semis', final:'Gran Final' };

    // Si el destino ya está ACTIVO ahora mismo, los usuarios reales verían este
    // partido de prueba de inmediato (aunque nunca afecte el puntaje real —
    // ver la exclusión de 'test_match' en recalcularPuntos). Confirmar antes.
    if (phase !== 'test') {
      try {
        const cfgSnap = await this.db.doc('config/main').get();
        const cfg = cfgSnap.exists ? cfgSnap.data() : {};
        const isActive = phase === 'league'
          ? (cfg.jornadasActivas || []).includes(targetMatchday)
          : (cfg.fasesActivas || []).includes(phase);
        if (isActive && !confirm(
          '⚠️ ' + (label[phase] || phase) + ' está ACTIVA ahora mismo.\n\n' +
          'Los usuarios reales van a ver este partido de prueba de inmediato ' +
          '(no afecta el puntaje final, pero sí es visible y predecible).\n\n¿Continuar?'
        )) return;
      } catch(e) { /* si falla la verificación de config, no bloquear la acción */ }
    }

    try {
      await this.db.doc('matches/test_match').update(update);
      this.toast('✅ Partido movido a ' + (label[phase] || phase), 'success');
      this._renderPartidosPrueba(document.getElementById('cha-partidos-content'));
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error: ' + (e.message || e.code), 'error');
    }
  },

  /* ── Carga masiva de partidos de Liga por CSV ──
     Los ids de partido siguen exactamente el mismo patrón que seedJornadaMatches
     ('league_md{JJ}_match{NN}'), así que esto sirve tanto para completar los
     slots vacíos creados por "seed" como para crearlos de cero. ── */
  _parseCSVRows(raw) {
    return raw.split('\n').map(l => l.trim()).filter(Boolean).map(line => {
      const sep = line.includes('\t') ? '\t' : ',';
      return line.split(sep).map(c => c.trim());
    });
  },

  previewCSVImport() {
    const raw = document.getElementById('cha-csv-input')?.value || '';
    const previewEl = document.getElementById('cha-csv-preview');
    if (!previewEl) return;
    const rows = this._parseCSVRows(raw);
    if (rows.length === 0) {
      previewEl.innerHTML = '<div style="color:var(--ca-muted);font-size:12px">Pegá al menos una fila.</div>';
      return;
    }

    const parsed = [];
    const errors = [];
    rows.forEach((cols, i) => {
      if (cols.length < 6) { errors.push('Fila ' + (i + 1) + ': faltan columnas (mínimo jornada, partido, local, bandera local, visitante, bandera visitante)'); return; }
      const [jStr, numStr, homeTeamName, homeTeamFlag, awayTeamName, awayTeamFlag, venue, lockAtStr] = cols;
      const jornada = parseInt(jStr, 10);
      const num = parseInt(numStr, 10);
      if (!jornada || jornada < 1 || jornada > 8) { errors.push('Fila ' + (i + 1) + ': jornada inválida (1-8)'); return; }
      if (!num || num < 1 || num > 18) { errors.push('Fila ' + (i + 1) + ': número de partido inválido (1-18)'); return; }
      if (!homeTeamName || !awayTeamName) { errors.push('Fila ' + (i + 1) + ': faltan nombres de equipo'); return; }
      let lockAt = null;
      if (lockAtStr) {
        const d = new Date(lockAtStr.replace(' ', 'T'));
        if (!isNaN(d.getTime())) lockAt = d.toISOString();
        else errors.push('Fila ' + (i + 1) + ': fecha de cierre inválida (usá aaaa-mm-dd hh:mm)');
      }
      const mid = 'league_md' + String(jornada).padStart(2, '0') + '_match' + String(num).padStart(2, '0');
      parsed.push({ mid, jornada, num, homeTeamName, homeTeamFlag: homeTeamFlag || '⚽', awayTeamName, awayTeamFlag: awayTeamFlag || '⚽', venue: venue || '', lockAt });
    });

    this._pendingCSVImport = parsed;
    let html = '';
    if (errors.length > 0) {
      html += '<div style="padding:10px 14px;margin-bottom:10px;border-radius:8px;background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.3);font-size:12px;color:#f87171;line-height:1.6">' +
        errors.map(e => chaEsc(e)).join('<br>') + '</div>';
    }
    if (parsed.length > 0) {
      html += '<div style="overflow-x:auto"><table class="ca-table" style="margin-bottom:12px"><thead><tr>' +
        '<th>J</th><th>#</th><th>Local</th><th>Visitante</th><th>Estadio</th><th>Cierre</th>' +
        '</tr></thead><tbody>' +
        parsed.map(p => '<tr><td>' + p.jornada + '</td><td>' + p.num + '</td>' +
          '<td>' + chaEsc(p.homeTeamFlag) + ' ' + chaEsc(p.homeTeamName) + '</td>' +
          '<td>' + chaEsc(p.awayTeamFlag) + ' ' + chaEsc(p.awayTeamName) + '</td>' +
          '<td>' + chaEsc(p.venue) + '</td>' +
          '<td>' + (p.lockAt ? new Date(p.lockAt).toLocaleString() : '—') + '</td></tr>').join('') +
        '</tbody></table></div>' +
        '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.confirmCSVImport()">✅ Confirmar e importar ' + parsed.length + ' partido' + (parsed.length === 1 ? '' : 's') + '</button>';
    }
    previewEl.innerHTML = html;
  },

  async confirmCSVImport() {
    const parsed = this._pendingCSVImport;
    if (!parsed || parsed.length === 0) return;
    try {
      const batch = this.db.batch();
      parsed.forEach(p => {
        const data = {
          phase: 'league', matchday: p.jornada, matchOrder: p.num,
          homeTeamName: p.homeTeamName, homeTeamFlag: p.homeTeamFlag,
          awayTeamName: p.awayTeamName, awayTeamFlag: p.awayTeamFlag,
          venue: p.venue, status: 'scheduled',
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        };
        if (p.lockAt) data.lockAt = p.lockAt;
        batch.set(this.db.doc('matches/' + p.mid), data, { merge: true });
      });
      await batch.commit();
      this.toast('✅ Importados ' + parsed.length + ' partidos', 'success');
      this._pendingCSVImport = null;
      this.renderPartidos();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al importar.', 'error');
    }
  },

  async _renderPartidosLiga(cont) {
    const j = this._currentJornada || 1;
    const jStr = String(j).padStart(2, '0');

    let html = '<div class="cha-jornada-picker">';
    for (let i = 1; i <= 8; i++) {
      html += '<button class="cha-jornada-btn' + (i === j ? ' active' : '') +
        '" onclick="CHAdmin._pickJornada(' + i + ')">J' + i + '</button>';
    }
    html += '</div>';

    html += '<div class="ca-info-box">' +
      '<div class="ca-info-box-text">' +
        '<div class="ca-info-box-title">Jornada ' + j + ' — Inicializar partidos</div>' +
        '<div class="ca-info-box-sub">Crea los 18 slots de esta jornada como "Por definir". También podés crear los 144 a la vez.</div>' +
      '</div>' +
      '<div style="display:flex;gap:8px;flex-wrap:wrap">' +
        '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.seedJornadaMatches(' + j + ')">⚡ J' + j + ' (18)</button>' +
        '<button class="cha-btn" style="background:rgba(255,255,255,.05);border:1px solid var(--ca-border2)" onclick="CHAdmin.seedLigaMatches()">Todos 144</button>' +
      '</div>' +
    '</div>';

    html += '<div class="cha-card" style="margin-bottom:20px;border-color:rgba(0,207,255,.25)">' +
      '<div style="font-size:13px;font-weight:700;color:var(--ca-text);margin-bottom:6px">📥 Carga masiva por CSV</div>' +
      '<div style="font-size:11.5px;color:var(--ca-muted);margin-bottom:10px">Una fila por partido: <code style="background:rgba(255,255,255,.05);padding:1px 5px;border-radius:4px">jornada,partido(1-18),local,bandera local,visitante,bandera visitante,estadio,cierre (aaaa-mm-dd hh:mm)</code>. Se puede pegar directo desde Excel/Sheets — completa o actualiza los partidos ya existentes.</div>' +
      '<textarea id="cha-csv-input" class="cha-input" rows="4" placeholder="1,1,Real Madrid,🇪🇸,Manchester City,🇬🇧,Santiago Bernabéu,2026-09-16 19:00" style="width:100%;font-family:monospace;font-size:11.5px;margin-bottom:10px;resize:vertical"></textarea>' +
      '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.previewCSVImport()">👁️ Previsualizar</button>' +
      '<div id="cha-csv-preview" style="margin-top:12px"></div>' +
    '</div>';

    let snap = await this.db.collection('matches')
      .where('phase', '==', 'league').where('matchday', '==', j).get();
    if (snap.empty) {
      snap = await this.db.collection('matches')
        .where('fase', '==', 'liga').where('jornada', '==', j).get();
    }
    const existingMap = {};
    snap.forEach(doc => { existingMap[doc.id] = doc.data(); });
    const created = Object.keys(existingMap).length;

    html += '<div style="font-size:10px;letter-spacing:2px;color:var(--ca-muted);text-transform:uppercase;margin-bottom:14px;font-weight:700">' +
      'JORNADA ' + j + ' — ' + created + ' / 18 CREADOS' +
    '</div><div style="display:grid;gap:10px">';

    for (let num = 1; num <= 18; num++) {
      const mid = 'league_md' + jStr + '_match' + String(num).padStart(2, '0');
      html += existingMap[mid]
        ? this._matchEditCard(mid, existingMap[mid], false)
        : this._matchEmptySlot(mid, 'Jornada ' + j + ' · Partido ' + num);
    }
    html += '</div>';
    cont.innerHTML = html;
  },

  async _renderPartidosElim(cont, phase) {
    const f = this.FASES_ELIM.find(x => x.id === phase);
    if (!f) return;

    let snap = await this.db.collection('matches').where('phase', '==', phase).get();
    if (snap.empty) {
      snap = await this.db.collection('matches').where('fase', '==', phase).get();
    }
    const existingMap = {};
    snap.forEach(doc => { existingMap[doc.id] = doc.data(); });
    const created = Object.keys(existingMap).length;
    const total = phase === 'final' ? 1 : f.ties * f.legs;

    let html = '<div class="ca-info-box">' +
      '<div class="ca-info-box-text">' +
        '<div class="ca-info-box-title">Inicializar ' + f.nombre + '</div>' +
        '<div class="ca-info-box-sub">' +
          f.ties + (f.legs === 2 ? ' llaves × 2 partidos (ida + vuelta)' : ' partido único') +
          ' — ' + created + '/' + total + ' creados' +
        '</div>' +
      '</div>' +
      '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.seedKnockoutMatches(\'' + phase + '\')">⚡ INICIALIZAR</button>' +
    '</div>';

    if (phase === 'final') {
      const mid = 'final_match';
      html += existingMap[mid]
        ? this._matchEditCard(mid, existingMap[mid], true)
        : this._matchEmptySlot(mid, 'GRAN FINAL');
    } else {
      for (let t = 1; t <= f.ties; t++) {
        const tieId = phase + '_tie' + String(t).padStart(2, '0');
        html += '<div style="margin-bottom:20px">' +
          '<div style="font-size:10px;letter-spacing:2px;color:var(--ca-muted);text-transform:uppercase;font-weight:700;margin-bottom:10px;padding-bottom:8px;border-bottom:1px solid var(--ca-border)">LLAVE ' + t + '</div>';
        for (let leg = 1; leg <= f.legs; leg++) {
          const mid = tieId + '_leg' + leg;
          html += existingMap[mid]
            ? this._matchEditCard(mid, existingMap[mid], true)
            : this._matchEmptySlot(mid, 'Llave ' + t + ' · ' + (leg === 1 ? 'IDA' : 'VUELTA'));
        }
        html += '</div>';
      }
    }

    cont.innerHTML = html;
  },

  _pickJornada(j) {
    this._currentJornada = j;
    document.querySelectorAll('.cha-jornada-btn').forEach((b, i) => b.classList.toggle('active', i + 1 === j));
    this._renderPartidosLiga(document.getElementById('cha-partidos-content'));
  },

  _matchEditCard(mid, m, isElim) {
    const homeTeam = m.homeTeamName || m.local || '';
    const awayTeam = m.awayTeamName || m.visitante || '';
    const homeFlag = m.homeTeamFlag || m.flagLocal || '⚽';
    const awayFlag = m.awayTeamFlag || m.flagVisitante || '⚽';
    const venue    = m.venue || m.estadio || '';
    const lockRaw  = m.lockAt || (m.deadline && m.deadline.toDate ? m.deadline.toDate().toISOString() : m.deadline);
    const lockVal  = this.toLocalInputValue(lockRaw);
    const kickVal  = this.toLocalInputValue(m.kickoffAt || '');
    const tieId    = isElim ? (m.tieId || m.eliminatoria || '') : '';
    const legLabel = m.leg === 1 ? 'IDA' : m.leg === 2 ? 'VUELTA' : (m.leg ? 'PARTIDO ' + m.leg : '');

    const statusOpts = ['pending_teams','scheduled','open','locked','live','finished','postponed','cancelled']
      .map(s => '<option value="' + s + '"' + (m.status === s ? ' selected' : '') + '>' + s + '</option>')
      .join('');

    return '<div class="cha-card" id="pcard-' + chaEsc(mid) + '">' +

      // Card header
      '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:16px;flex-wrap:wrap">' +
        '<div>' +
          '<div style="font-size:9px;letter-spacing:2px;color:var(--ca-muted);font-weight:700">' +
            chaEsc(mid) + (legLabel ? ' · ' + legLabel : '') +
          '</div>' +
          (tieId ? '<div style="font-size:10px;color:var(--ca-muted);margin-top:2px">' + chaEsc(tieId) + '</div>' : '') +
        '</div>' +
        '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">' +
          this.statusBadge(m.status || 'pending_teams') +
          '<select onchange="CHAdmin.saveMatchStatus(\'' + chaEsc(mid) + '\',this.value)" class="cha-input" style="font-size:11px;padding:5px 8px">' +
            statusOpts +
          '</select>' +
        '</div>' +
      '</div>' +

      // Teams
      '<div class="ca-match-teams-grid">' +
        '<div>' +
          '<label class="cha-label">Local</label>' +
          '<div class="ca-match-team-pair">' +
            '<input class="cha-input ca-match-team-flag" type="text" value="' + chaEsc(homeFlag) + '" maxlength="8" placeholder="🏴" id="hf-' + chaEsc(mid) + '" title="Emoji de bandera">' +
            '<input class="cha-input" type="text" value="' + chaEsc(homeTeam) + '" placeholder="Por definir" id="hn-' + chaEsc(mid) + '" style="flex:1">' +
          '</div>' +
        '</div>' +
        '<div style="text-align:center;padding-top:22px;color:var(--ca-muted);font-family:\'Bebas Neue\',sans-serif;font-size:15px">VS</div>' +
        '<div>' +
          '<label class="cha-label">Visitante</label>' +
          '<div class="ca-match-team-pair">' +
            '<input class="cha-input ca-match-team-flag" type="text" value="' + chaEsc(awayFlag) + '" maxlength="8" placeholder="🏴" id="af-' + chaEsc(mid) + '" title="Emoji de bandera">' +
            '<input class="cha-input" type="text" value="' + chaEsc(awayTeam) + '" placeholder="Por definir" id="an-' + chaEsc(mid) + '" style="flex:1">' +
          '</div>' +
        '</div>' +
      '</div>' +

      // Fecha + Cierre + Estadio + Save
      '<div class="ca-match-meta-row">' +
        '<div>' +
          '<label class="cha-label">📅 Fecha del partido</label>' +
          '<input class="cha-input" type="datetime-local" value="' + kickVal + '" id="ko-' + chaEsc(mid) + '" style="width:100%">' +
        '</div>' +
        '<div>' +
          '<label class="cha-label">🔒 Cierre de predicciones</label>' +
          '<input class="cha-input" type="datetime-local" value="' + lockVal + '" id="la-' + chaEsc(mid) + '" style="width:100%">' +
        '</div>' +
        '<div>' +
          '<label class="cha-label">Estadio / Sede</label>' +
          '<input class="cha-input" type="text" value="' + chaEsc(venue) + '" placeholder="Estadio" id="ve-' + chaEsc(mid) + '" style="width:100%">' +
        '</div>' +
        '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.saveMatchData(\'' + chaEsc(mid) + '\')" style="align-self:end">💾 GUARDAR</button>' +
      '</div>' +

      this._sponsorSection(mid, m) +

    '</div>';
  },

  _matchEmptySlot(mid, label) {
    return '<div class="cha-card" style="border-style:dashed;border-color:rgba(255,20,100,.2);background:rgba(255,20,100,.02);display:flex;align-items:center;justify-content:space-between;gap:12px;padding:16px 20px;flex-wrap:wrap">' +
      '<div>' +
        '<div style="font-size:9px;letter-spacing:2px;color:var(--ca-muted);font-weight:700;margin-bottom:5px">' + chaEsc(mid) + '</div>' +
        '<div style="font-size:13px;color:var(--ca-muted)">⚽ ' + chaEsc(label) + ' — <em style="font-size:12px">Sin crear</em></div>' +
      '</div>' +
      '<button class="cha-btn cha-btn-sm" style="border:1px solid rgba(255,20,100,.4);color:var(--ca-gold);background:transparent" ' +
        'onclick="CHAdmin.createSingleMatch(\'' + chaEsc(mid) + '\')">+ CREAR</button>' +
    '</div>';
  },

  async createSingleMatch(mid) {
    const data = {
      homeTeamName: 'Por definir', homeTeamFlag: '⚽',
      awayTeamName: 'Por definir', awayTeamFlag: '⚽',
      homeTeamId: null, awayTeamId: null,
      venue: '', lockAt: null, kickoffAt: null,
      status: 'pending_teams', visible: true,
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    };
    if (mid.startsWith('league_')) {
      const parts = mid.split('_');
      data.phase = 'league';
      data.matchday = parseInt(parts[1].replace('md', ''));
      data.matchOrder = parseInt(parts[2].replace('match', ''));
    } else if (mid === 'final_match') {
      data.phase = 'final'; data.tieId = 'final'; data.leg = 1; data.matchOrder = 1;
    } else {
      const parts = mid.split('_');
      data.phase = parts[0];
      data.tieId = parts[0] + '_' + parts[1];
      data.leg = parseInt(parts[2].replace('leg', ''));
      data.matchOrder = (parseInt(parts[1].replace('tie', '')) - 1) * 2 + data.leg;
    }
    try {
      await this.db.doc('matches/' + mid).set(data, { merge: true });
      this.toast('✅ ' + mid + ' creado', 'success');
      this.renderStats();
      this.renderPartidos();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error: ' + (e.message || e.code), 'error');
    }
  },

  async seedJornadaMatches(j) {
    if (!confirm('¿Crear los 18 partidos de Jornada ' + j + '?\nSolo se crean los que no existen aún.')) return;
    const jStr = String(j).padStart(2, '0');
    try {
      const existing = new Set();
      const snap = await this.db.collection('matches')
        .where('phase', '==', 'league').where('matchday', '==', j).get();
      snap.forEach(d => existing.add(d.id));
      const now = firebase.firestore.FieldValue.serverTimestamp();
      const batch = this.db.batch();
      let created = 0;
      for (let num = 1; num <= 18; num++) {
        const mid = 'league_md' + jStr + '_match' + String(num).padStart(2, '0');
        if (existing.has(mid)) continue;
        batch.set(this.db.doc('matches/' + mid), {
          phase: 'league', matchday: j, matchOrder: num,
          homeTeamName: 'Por definir', homeTeamFlag: '⚽',
          awayTeamName: 'Por definir', awayTeamFlag: '⚽',
          homeTeamId: null, awayTeamId: null,
          venue: '', lockAt: null, kickoffAt: null,
          status: 'pending_teams', createdAt: now
        });
        created++;
      }
      await batch.commit();
      this.toast('✅ ' + created + ' partidos de J' + j + ' creados (' + (18 - created) + ' ya existían)', 'success');
      this.renderStats();
      this.renderPartidos();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error: ' + (e.message || e.code), 'error');
    }
  },

  async saveMatchData(mid) {
    const hf = document.getElementById('hf-' + mid)?.value.trim() || '⚽';
    const hn = document.getElementById('hn-' + mid)?.value.trim() || 'Por definir';
    const af = document.getElementById('af-' + mid)?.value.trim() || '⚽';
    const an = document.getElementById('an-' + mid)?.value.trim() || 'Por definir';
    const ve = document.getElementById('ve-' + mid)?.value.trim() || '';
    const kr = document.getElementById('ko-' + mid)?.value || '';
    const kickoffAt = kr ? new Date(kr).toISOString() : null;
    const lr = document.getElementById('la-' + mid)?.value || '';
    const lockAt = lr ? new Date(lr).toISOString() : null;

    try {
      const data = {
        homeTeamName: hn, homeTeamFlag: hf,
        awayTeamName: an, awayTeamFlag: af,
        venue: ve, updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      };
      if (kickoffAt) data.kickoffAt = kickoffAt;
      if (lockAt) data.lockAt = lockAt;
      if (hn !== 'Por definir' || an !== 'Por definir') data.status = 'scheduled';
      await this.db.doc('matches/' + mid).set(data, { merge: true });
      this.toast('✅ ' + hn + ' vs ' + an + ' guardado', 'success');
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar.', 'error');
    }
  },

  /* ── Sponsor helpers ──────────────────────────────── */
  _sponsorSection(mid, m) {
    const hasLogo = !!(m && m.sponsorLogo);
    const name    = (m && m.sponsorName) || '';
    return '<div style="margin-top:14px;padding:14px 16px;background:rgba(255,20,100,.03);border:1px solid rgba(255,20,100,.12);border-radius:10px" id="sp-wrap-' + chaEsc(mid) + '">' +
      '<div style="font-size:10px;letter-spacing:2px;color:var(--ca-gold);font-weight:700;margin-bottom:10px">🎯 PATROCINADOR <span style="font-size:9px;color:var(--ca-muted);letter-spacing:0;font-weight:400;text-transform:none">(opcional — aparece en la tarjeta del usuario)</span></div>' +
      '<div style="display:grid;grid-template-columns:1fr auto;gap:10px;align-items:end;margin-bottom:10px">' +
        '<div>' +
          '<label class="cha-label">Nombre del patrocinador</label>' +
          '<input class="cha-input" type="text" id="sp-name-' + chaEsc(mid) + '" value="' + chaEsc(name) + '" placeholder="Ej: Soccer Revolution" style="width:100%">' +
        '</div>' +
        '<button class="cha-btn cha-btn-sm" onclick="CHAdmin.saveSponsor(\'' + chaEsc(mid) + '\')" style="border:1px solid rgba(255,20,100,.4);color:var(--ca-gold);background:transparent;white-space:nowrap">💾 GUARDAR</button>' +
      '</div>' +
      '<label class="cha-label">Logo (PNG transparente recomendado · max 500KB)</label>' +
      '<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-top:6px">' +
        '<label style="cursor:pointer;display:inline-flex;align-items:center;gap:6px;padding:8px 14px;border:1px dashed rgba(255,20,100,.3);border-radius:8px;font-size:12px;color:var(--ca-muted);background:var(--ca-input)">' +
          '📎 Seleccionar imagen' +
          '<input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" style="display:none" onchange="CHAdmin.previewSponsorLogo(this,\'' + chaEsc(mid) + '\')">' +
        '</label>' +
        '<div id="sp-preview-' + chaEsc(mid) + '" style="display:flex;align-items:center;gap:8px">' +
          (hasLogo
            ? '<img src="' + m.sponsorLogo + '" style="height:36px;max-width:120px;object-fit:contain;background:rgba(255,255,255,.06);border-radius:6px;padding:4px 8px"><button onclick="CHAdmin.removeSponsorLogo(\'' + chaEsc(mid) + '\')" style="background:none;border:none;color:var(--ca-muted);cursor:pointer;font-size:16px" title="Quitar logo">✕</button>'
            : '<span style="font-size:11px;color:var(--ca-muted)">Sin logo</span>'
          ) +
        '</div>' +
      '</div>' +
    '</div>';
  },

  previewSponsorLogo(input, mid) {
    const file = input.files[0];
    if (!file) return;
    if (file.size > 500 * 1024) { this.toast('Imagen demasiado grande (máx 500KB)', 'error'); return; }
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        // Redimensionar a max 800×300 manteniendo ratio
        const MAX_W = 800, MAX_H = 300;
        let w = img.width, h = img.height;
        if (w > MAX_W || h > MAX_H) {
          const ratio = Math.min(MAX_W / w, MAX_H / h);
          w = Math.round(w * ratio); h = Math.round(h * ratio);
        }
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        const dataUrl = canvas.toDataURL('image/png');
        // Guardar en input oculto y previsualizar
        let hidden = document.getElementById('sp-data-' + mid);
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.id = 'sp-data-' + mid;
          document.getElementById('sp-wrap-' + mid)?.appendChild(hidden);
        }
        hidden.value = dataUrl;
        const prev = document.getElementById('sp-preview-' + mid);
        if (prev) prev.innerHTML = '<img src="' + dataUrl + '" style="height:36px;max-width:120px;object-fit:contain;background:rgba(255,255,255,.06);border-radius:6px;padding:4px 8px"><button onclick="CHAdmin.removeSponsorLogo(\'' + chaEsc(mid) + '\')" style="background:none;border:none;color:var(--ca-muted);cursor:pointer;font-size:16px">✕</button>';
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  },

  async removeSponsorLogo(mid) {
    try {
      await this.db.doc('matches/' + mid).set({ sponsorLogo: firebase.firestore.FieldValue.delete() }, { merge: true });
      const prev = document.getElementById('sp-preview-' + mid);
      if (prev) prev.innerHTML = '<span style="font-size:11px;color:var(--ca-muted)">Sin logo</span>';
      const hidden = document.getElementById('sp-data-' + mid);
      if (hidden) hidden.value = '';
      this.toast('Logo eliminado', 'success');
    } catch(e) { this.toast('Error al eliminar logo', 'error'); }
  },

  async saveSponsor(mid) {
    const nameInput = document.getElementById('sp-name-' + mid);
    const hidden    = document.getElementById('sp-data-' + mid);
    const name      = nameInput?.value.trim() || '';
    const logo      = hidden?.value || null;
    const data = { sponsorName: name };
    if (logo) data.sponsorLogo = logo;
    try {
      await this.db.doc('matches/' + mid).set(data, { merge: true });
      this.toast('✅ Patrocinador guardado', 'success');
    } catch(e) { this.toast('Error al guardar patrocinador', 'error'); }
  },

  async saveMatchStatus(mid, status) {
    try {
      await this.db.doc('matches/' + mid).set(
        { status, updatedAt: firebase.firestore.FieldValue.serverTimestamp() },
        { merge: true }
      );
      this.toast('Estado → ' + status, 'success');
    } catch(e) {
      this.toast('Error al cambiar estado.', 'error');
    }
  },

  /* ── Seed Liga ─────────────────────────────────────── */
  async seedLigaMatches() {
    if (!confirm('¿Crear los 144 partidos de liga (8 × 18) con equipos "Por definir"?\nNo se tocan los partidos que ya existen.')) return;

    const cont = document.getElementById('cha-partidos-content');
    if (cont) cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px;text-align:center">⏳ Verificando partidos existentes...</div>';

    try {
      const existing = new Set();
      const snap = await this.db.collection('matches').where('phase', '==', 'league').get();
      snap.forEach(d => existing.add(d.id));

      const now = firebase.firestore.FieldValue.serverTimestamp();
      let batch = this.db.batch();
      let count = 0, created = 0;

      for (let md = 1; md <= 8; md++) {
        for (let num = 1; num <= 18; num++) {
          const mid = 'league_md' + String(md).padStart(2,'0') + '_match' + String(num).padStart(2,'0');
          if (existing.has(mid)) continue;
          batch.set(this.db.doc('matches/' + mid), {
            phase: 'league', matchday: md, matchOrder: num,
            homeTeamName: 'Por definir', homeTeamFlag: '⚽',
            awayTeamName: 'Por definir', awayTeamFlag: '⚽',
            homeTeamId: null, awayTeamId: null,
            venue: '', kickoffAt: null, lockAt: null,
            status: 'pending_teams', createdAt: now
          });
          count++;
          created++;
          if (count === 499) {
            await batch.commit();
            batch = this.db.batch();
            count = 0;
          }
        }
      }
      if (count > 0) await batch.commit();

      this.toast('✅ ' + created + ' partidos creados (' + (144 - created) + ' ya existían)', 'success');
      this.renderStats();
      this._currentJornada = 1;
      this.renderPartidos();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al crear: ' + (e.message || e.code), 'error');
      this.renderPartidos();
    }
  },

  /* ── Seed Knockout ─────────────────────────────────── */
  async seedKnockoutMatches(phase) {
    const f = this.FASES_ELIM.find(x => x.id === phase);
    if (!f) return;
    if (!confirm('¿Crear los partidos de ' + f.nombre + '?\nSolo se crean partidos que no existen aún.')) return;

    try {
      const existing = new Set();
      const snap = await this.db.collection('matches').where('phase', '==', phase).get();
      snap.forEach(d => existing.add(d.id));

      const now = firebase.firestore.FieldValue.serverTimestamp();
      const batch = this.db.batch();
      let created = 0;

      for (let t = 1; t <= f.ties; t++) {
        const tieId = phase + '_tie' + String(t).padStart(2,'0');
        for (let leg = 1; leg <= f.legs; leg++) {
          const mid = phase === 'final' ? 'final_match' : (tieId + '_leg' + leg);
          if (existing.has(mid)) continue;
          batch.set(this.db.doc('matches/' + mid), {
            phase, tieId: phase === 'final' ? 'final' : tieId,
            leg, matchOrder: (t - 1) * f.legs + leg,
            homeTeamName: 'Por definir', homeTeamFlag: '⚽',
            awayTeamName: 'Por definir', awayTeamFlag: '⚽',
            homeTeamId: null, awayTeamId: null,
            venue: '', kickoffAt: null, lockAt: null,
            status: 'pending_teams', createdAt: now
          });
          created++;
        }
      }
      await batch.commit();
      this.toast('✅ ' + created + ' partidos de ' + f.nombre + ' creados', 'success');
      this.renderStats();
      this.renderPartidos();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al crear: ' + (e.message || e.code), 'error');
    }
  },

  /* ══════════════════════════════════════════════════
     TAB: RESULTADOS
  ══════════════════════════════════════════════════ */
  selectResultPhase(phase) {
    this._currentPhaseResult = phase;
    document.querySelectorAll('#cha-result-phase-tabs .cha-sub-tab').forEach(b => b.classList.toggle('active', b.dataset.phase === phase));
    if (phase === 'league') this._currentResultJornada = 1;
    this.renderResultados();
  },

  /* ── Aviso: partidos ya cerrados (lockAt pasado) sin resultado cargado ──
     Recorre TODOS los partidos, no solo la jornada/fase que se esté viendo,
     para que el admin no se olvide de cargar un resultado atrasado. ── */
  async _renderResultsAlert() {
    const cont = document.getElementById('cha-results-alert');
    if (!cont) return;
    try {
      const [matchesSnap, resultsSnap] = await Promise.all([
        this.db.collection('matches').get(),
        this.db.collection('results').get()
      ]);
      const results = {};
      resultsSnap.forEach(d => { results[d.id] = d.data(); });

      const now = new Date();
      const pending = [];
      matchesSnap.forEach(doc => {
        if (doc.id === 'test_match') return;
        const m = doc.data();
        const lockRaw = m.lockAt || m.deadline;
        if (!lockRaw) return;
        const lockDate = lockRaw.toDate ? lockRaw.toDate() : new Date(lockRaw);
        if (isNaN(lockDate.getTime()) || lockDate > now) return;
        const r = results[doc.id];
        if (r && r.homeScore != null) return;
        const homeTeam = m.homeTeamName || m.local || '?';
        const awayTeam = m.awayTeamName || m.visitante || '?';
        pending.push({ label: homeTeam + ' vs ' + awayTeam, lockDate });
      });

      if (pending.length === 0) { cont.innerHTML = ''; return; }
      pending.sort((a, b) => a.lockDate - b.lockDate);

      cont.innerHTML = '<div style="padding:12px 16px;margin-bottom:16px;border-radius:12px;background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.3)">' +
        '<div style="font-size:13px;font-weight:700;color:#f87171;margin-bottom:6px">⚠️ ' + pending.length + ' partido' + (pending.length === 1 ? '' : 's') +
          ' cerrado' + (pending.length === 1 ? '' : 's') + ' sin resultado cargado</div>' +
        '<div style="font-size:12px;color:var(--ca-muted)">' +
          pending.slice(0, 5).map(p => chaEsc(p.label)).join(' · ') +
          (pending.length > 5 ? ' y ' + (pending.length - 5) + ' más' : '') +
        '</div>' +
      '</div>';
    } catch(e) {
      cont.innerHTML = '';
    }
  },

  async renderResultados() {
    this._renderResultsAlert();
    const cont = document.getElementById('cha-results-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px">Cargando...</div>';
    try {
      if (this._currentPhaseResult === 'league') {
        await this._renderResultadosLiga(cont);
      } else {
        await this._renderResultadosElim(cont, this._currentPhaseResult);
      }
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      cont.innerHTML = '<div style="color:var(--ca-red);padding:20px">Error: ' + chaEsc(e.message || e.code) + '</div>';
    }
  },

  async _renderResultadosLiga(cont) {
    const j = this._currentResultJornada || 1;
    let html = '<div class="cha-jornada-picker">';
    for (let i = 1; i <= 8; i++) {
      html += '<button class="cha-jornada-btn' + (i === j ? ' active' : '') +
        '" onclick="CHAdmin._pickResultJornada(' + i + ')">J' + i + '</button>';
    }
    html += '</div>';

    let matchSnap = await this.db.collection('matches')
      .where('phase', '==', 'league').where('matchday', '==', j).get();
    if (matchSnap.empty) {
      matchSnap = await this.db.collection('matches')
        .where('fase', '==', 'liga').where('jornada', '==', j).get();
    }
    const matchDocs = [];
    matchSnap.forEach(d => matchDocs.push({ id: d.id, data: d.data() }));
    matchDocs.sort((a, b) => (a.data.matchOrder || a.data.num || 0) - (b.data.matchOrder || b.data.num || 0));

    const resultSnap = await this.db.collection('results').get();
    const results = {};
    resultSnap.forEach(d => { results[d.id] = d.data(); });

    html += '<div style="font-size:10px;letter-spacing:2px;color:var(--ca-muted);text-transform:uppercase;margin-bottom:12px;font-weight:700">JORNADA ' + j + ' — ' + matchDocs.length + ' PARTIDOS</div>';

    if (matchDocs.length === 0) {
      html += '<div class="ca-empty"><div class="ca-empty-icon">📋</div>Sin partidos en esta jornada.</div>';
    } else {
      matchDocs.forEach(({ id, data }) => { html += this._resultCard(id, data, results[id]); });
    }

    cont.innerHTML = html;
  },

  async _renderResultadosElim(cont, phase) {
    let matchSnap = await this.db.collection('matches').where('phase', '==', phase).get();
    if (matchSnap.empty) {
      matchSnap = await this.db.collection('matches').where('fase', '==', phase).get();
    }
    const matchDocs = [];
    matchSnap.forEach(d => matchDocs.push({ id: d.id, data: d.data() }));
    matchDocs.sort((a, b) => {
      const ta = a.data.tieId || a.data.eliminatoria || '';
      const tb = b.data.tieId || b.data.eliminatoria || '';
      if (ta !== tb) return ta < tb ? -1 : 1;
      return (a.data.leg || 0) - (b.data.leg || 0);
    });

    const resultSnap = await this.db.collection('results').get();
    const results = {};
    resultSnap.forEach(d => { results[d.id] = d.data(); });

    let html = '';
    if (matchDocs.length === 0) {
      html = '<div class="ca-empty"><div class="ca-empty-icon">📋</div>Sin partidos en esta fase.</div>';
    } else {
      matchDocs.forEach(({ id, data }) => { html += this._resultCard(id, data, results[id]); });
    }
    cont.innerHTML = html;
  },

  _pickResultJornada(j) {
    this._currentResultJornada = j;
    document.querySelectorAll('#cha-results-content .cha-jornada-btn').forEach((b, i) => b.classList.toggle('active', i + 1 === j));
    this._renderResultadosLiga(document.getElementById('cha-results-content'));
  },

  _resultCard(mid, m, result) {
    const homeTeam  = m.homeTeamName || m.local || 'Local';
    const awayTeam  = m.awayTeamName || m.visitante || 'Visitante';
    const homeFlag  = m.homeTeamFlag || m.flagLocal || '⚽';
    const awayFlag  = m.awayTeamFlag || m.flagVisitante || '⚽';
    const hasResult = result && result.homeScore != null;
    const legLabel  = m.leg === 1 ? ' · IDA' : m.leg === 2 ? ' · VUELTA' : '';
    const curFirst  = hasResult ? (result.firstScoringTeam || 'none') : '';
    const hLabel    = homeTeam.length > 16 ? homeTeam.substring(0,15) + '…' : homeTeam;
    const aLabel    = awayTeam.length > 16 ? awayTeam.substring(0,15) + '…' : awayTeam;

    return '<div class="cha-card' + (hasResult ? ' cha-card-highlight' : '') + '">' +

      // Header
      '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;flex-wrap:wrap;gap:10px">' +
        '<div>' +
          '<div style="font-size:10px;letter-spacing:1.5px;color:var(--ca-muted);font-weight:600;margin-bottom:5px">' + chaEsc(mid) + chaEsc(legLabel) + '</div>' +
          '<div style="font-size:15px;color:var(--ca-text);font-weight:600;display:flex;align-items:center;gap:6px;flex-wrap:wrap">' +
            '<span>' + chaEsc(homeFlag) + ' ' + chaEsc(homeTeam) + '</span>' +
            '<span style="color:var(--ca-muted);font-weight:400;font-size:12px">vs</span>' +
            '<span>' + chaEsc(awayTeam) + ' ' + chaEsc(awayFlag) + '</span>' +
          '</div>' +
        '</div>' +
        (hasResult
          ? '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:26px;color:var(--ca-gold);letter-spacing:3px;line-height:1">' + result.homeScore + ' — ' + result.awayScore + '</div>'
          : '<span class="cha-badge cha-badge-pending">Sin resultado</span>'
        ) +
      '</div>' +

      // Score form — two clear rows
      '<form onsubmit="CHAdmin.saveResult(event,\'' + chaEsc(mid) + '\')">' +
        '<div class="ca-score-wrap">' +

          // Row 1: score inputs
          '<div class="ca-score-row">' +
            '<div class="ca-score-team">' +
              '<label class="cha-label">' + chaEsc(hLabel) + '</label>' +
              '<input class="cha-input ca-score-input" type="number" name="homeScore" min="0" max="30" placeholder="0"' +
                ' value="' + (hasResult ? result.homeScore : '') + '">' +
            '</div>' +
            '<span class="ca-score-sep">—</span>' +
            '<div class="ca-score-team">' +
              '<label class="cha-label">' + chaEsc(aLabel) + '</label>' +
              '<input class="cha-input ca-score-input" type="number" name="awayScore" min="0" max="30" placeholder="0"' +
                ' value="' + (hasResult ? result.awayScore : '') + '">' +
            '</div>' +
          '</div>' +

          // Row 2: primer gol + save
          '<div class="ca-score-bottom">' +
            '<div class="ca-first-sel">' +
              '<label class="cha-label">¿Quién anota primero?</label>' +
              '<select name="firstScoringTeam" class="cha-input" style="width:100%;height:46px;font-size:13px">' +
                '<option value="home"' + (curFirst === 'home' ? ' selected' : '') + '>' + chaEsc(homeFlag) + ' ' + chaEsc(hLabel) + '</option>' +
                '<option value="none"' + (curFirst === 'none' || !curFirst ? ' selected' : '') + '>⚽ Sin goles (0–0)</option>' +
                '<option value="away"' + (curFirst === 'away' ? ' selected' : '') + '>' + chaEsc(awayFlag) + ' ' + chaEsc(aLabel) + '</option>' +
              '</select>' +
            '</div>' +
            '<button type="submit" class="cha-btn cha-btn-gold ca-score-save">' +
              (hasResult ? '🔄 Actualizar' : '✅ Guardar') +
            '</button>' +
          '</div>' +

        '</div>' +
      '</form>' +

    '</div>';
  },

  async saveResult(e, mid) {
    e.preventDefault();
    const form  = e.target;
    const hScore = parseInt(form.querySelector('[name="homeScore"]').value);
    const aScore = parseInt(form.querySelector('[name="awayScore"]').value);
    const first  = form.querySelector('[name="firstScoringTeam"]').value || 'none';

    if (isNaN(hScore) || isNaN(aScore)) {
      return this.toast('Ingresá los dos marcadores', 'error');
    }
    if (hScore < 0 || hScore > 30 || aScore < 0 || aScore > 30) {
      return this.toast('El marcador debe estar entre 0 y 30', 'error');
    }
    if (hScore === 0 && aScore === 0 && first !== 'none') {
      return this.toast('Si el resultado es 0-0, seleccioná "Sin goles"', 'error');
    }
    if ((hScore > 0 || aScore > 0) && first === 'none') {
      return this.toast('Si hay goles, indicá quién anotó primero', 'error');
    }

    const btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = '...'; }

    try {
      // Una sola transacción: si el resultado se guarda pero el partido no queda
      // marcado 'finished' (o viceversa), el usuario ve el marcador guardado en
      // "results" pero el partido sigue "abierto" para predecir — resultado
      // silenciosamente desincronizado. Ambas escrituras se hacen juntas o ninguna.
      await this.db.runTransaction(async (tx) => {
        tx.set(this.db.doc('results/' + mid), {
          homeScore: hScore, awayScore: aScore, firstScoringTeam: first,
          savedAt: firebase.firestore.FieldValue.serverTimestamp()
        }, { merge: true });
        tx.set(this.db.doc('matches/' + mid),
          { status: 'finished', homeScore: hScore, awayScore: aScore, firstScoringTeam: first, updatedAt: firebase.firestore.FieldValue.serverTimestamp() },
          { merge: true }
        );
      });
      this.toast('✅ ' + hScore + '–' + aScore + ' guardado. Recalculando puntos…', 'success');
      this.renderResultados();
      this.renderStats();
      // Sin esto, el ranking y ch_profile/main quedaban desactualizados hasta que el
      // admin recordara ir a la pestaña Puntos y presionar "Recalcular" a mano —
      // riesgo real de desincronía que no existe del lado Mundial (que calcula en vivo).
      await this.recalcularPuntos({ silent: true });
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      if (btn) { btn.disabled = false; btn.textContent = '✅'; }
      this.toast('Error al guardar.', 'error');
    }
  },

  /* ══════════════════════════════════════════════════
     TAB: PUNTOS
  ══════════════════════════════════════════════════ */
  async renderPuntos() {
    const cont = document.getElementById('cha-puntos-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px">Cargando...</div>';
    try {
      const pointsSnap = await this.db.doc('config/points').get();
      const pointsCfg  = pointsSnap.exists ? pointsSnap.data() : null;
      const phaseMap   = this._resolvePoints(pointsCfg);
      const racha      = this._resolveRacha(pointsCfg);

      const faseRow = (id, label, icono) => {
        const p = phaseMap[id];
        return '<div class="cha-card" style="margin-bottom:10px">' +
          '<div style="display:flex;align-items:center;gap:8px;margin-bottom:10px">' +
            '<span style="font-size:20px">' + icono + '</span>' +
            '<span style="font-family:\'Bebas Neue\',sans-serif;color:var(--ca-gold);letter-spacing:2px;font-size:15px">' + label + '</span>' +
          '</div>' +
          '<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px">' +
            '<div><label class="cha-label">RESULTADO CORRECTO</label>' +
              '<input class="cha-input" type="number" min="0" max="200" id="pts-' + id + '-resultado" value="' + p.resultado + '" style="text-align:center"></div>' +
            '<div><label class="cha-label">MARCADOR EXACTO</label>' +
              '<input class="cha-input" type="number" min="0" max="200" id="pts-' + id + '-exacto" value="' + p.exacto + '" style="text-align:center"></div>' +
            '<div><label class="cha-label">PRIMER GOL</label>' +
              '<input class="cha-input" type="number" min="0" max="200" id="pts-' + id + '-anotador" value="' + p.anotador + '" style="text-align:center"></div>' +
          '</div>' +
        '</div>';
      };

      let html = '<div style="font-size:11px;letter-spacing:2px;color:var(--ca-gold);font-weight:700;margin-bottom:12px">💰 PUNTOS POR FASE</div>';
      html += faseRow('league', 'FASE DE LIGA', '⚽');
      this.FASES_ELIM.forEach(f => { html += faseRow(f.id, f.nombre, f.icono); });

      html += '<div class="cha-card" style="margin-bottom:16px;border-color:rgba(255,20,100,.3)">' +
        '<div style="font-family:\'Bebas Neue\',sans-serif;color:var(--ca-gold);letter-spacing:2px;font-size:15px;margin-bottom:10px">🔥 BONUS RACHA</div>' +
        '<div style="display:grid;grid-template-columns:repeat(' + racha.length + ',1fr);gap:10px">' +
          racha.map((r, i) =>
            '<div>' +
              '<label class="cha-label">A LOS ' + r.n + ' ACIERTOS</label>' +
              '<input class="cha-input" type="number" min="0" max="200" id="racha-n-' + i + '" value="' + r.n + '" style="text-align:center;margin-bottom:4px">' +
              '<input class="cha-input" type="number" min="0" max="200" id="racha-bonus-' + i + '" value="' + r.bonus + '" style="text-align:center" title="Bono de puntos">' +
            '</div>'
          ).join('') +
        '</div>' +
      '</div>' +
      '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.savePuntos(' + racha.length + ')" style="font-size:13px;padding:10px 24px;margin-bottom:24px">💾 GUARDAR PUNTOS Y RECALCULAR</button>';

      html +=
        '<div class="cha-card" style="text-align:center;padding:32px 24px">' +
          '<div style="font-size:36px;margin-bottom:12px">🔄</div>' +
          '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:18px;letter-spacing:2px;color:var(--ca-gold);margin-bottom:8px">Recálculo manual</div>' +
          '<p style="font-size:12px;color:var(--ca-muted);max-width:440px;margin:0 auto 20px;line-height:1.6">' +
            'Los puntos ya se recalculan solos después de guardar un resultado o cambiar estos valores. Usá esto solo si necesitás forzar un recálculo puntual (ej. después de restaurar un respaldo).' +
          '</p>' +
          '<button class="cha-btn" style="border:1px solid var(--ca-border2)" onclick="CHAdmin.recalcularPuntos()">⚡ RECALCULAR AHORA</button>' +
        '</div>' +
        '<div id="cha-recalc-log"></div>';

      cont.innerHTML = html;
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      cont.innerHTML = '<div style="color:var(--ca-red);padding:20px">Error al cargar. Verificá tu conexión.</div>';
    }
  },

  async savePuntos(rachaCount) {
    const num = (id, dflt) => {
      const v = parseInt(document.getElementById(id)?.value, 10);
      return isNaN(v) ? dflt : Math.max(0, Math.min(200, v));
    };
    const points = { league: {
      resultado: num('pts-league-resultado', 2), exacto: num('pts-league-exacto', 7), anotador: num('pts-league-anotador', 2)
    } };
    this.FASES_ELIM.forEach(f => {
      points[f.id] = {
        resultado: num('pts-' + f.id + '-resultado', f.pts.resultado),
        exacto:    num('pts-' + f.id + '-exacto',    f.pts.exacto),
        anotador:  num('pts-' + f.id + '-anotador',  f.pts.anotador)
      };
    });
    const racha = [];
    for (let i = 0; i < rachaCount; i++) {
      racha.push({ n: num('racha-n-' + i, 0), bonus: num('racha-bonus-' + i, 0) });
    }
    points.racha = racha;
    try {
      await this.db.doc('config/points').set(points);
      this.toast('✅ Puntos guardados. Recalculando a todos los participantes…', 'success');
      await this.recalcularPuntos({ silent: true });
      this.toast('✅ Recálculo completo con los nuevos puntos', 'success');
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar. Verificá tu conexión.', 'error');
    }
  },

  // Wrapper con guardia de superposición: sin esto, si el admin cargaba varios
  // resultados seguidos (flujo normal: cargar una jornada entera rápido), cada
  // uno disparaba su propio recalcularPuntos({silent:true}) en paralelo. Cada
  // llamada lee su propia foto de matches/results/users en ese instante, así
  // que la que arrancó ANTES (con datos más viejos) podía terminar de escribir
  // DESPUÉS que la más nueva, pisando los totales correctos con unos viejos —
  // sin ningún error visible. Ahora, si ya hay un recálculo en curso, la
  // llamada nueva no arranca un segundo cálculo en paralelo: solo marca que
  // hace falta una pasada más al terminar, para no perder la data más reciente.
  async recalcularPuntos(opts) {
    if (this._recalcInFlight) { this._recalcRerunNeeded = true; return; }
    this._recalcInFlight = true;
    try {
      await this._recalcularPuntosImpl(opts);
    } finally {
      this._recalcInFlight = false;
      if (this._recalcRerunNeeded) {
        this._recalcRerunNeeded = false;
        await this.recalcularPuntos({ silent: true });
      }
    }
  },

  async _recalcularPuntosImpl(opts) {
    opts = opts || {};
    const logEl = opts.silent ? null : document.getElementById('cha-recalc-log');
    const log = (msg, color) => {
      if (!logEl) return;
      logEl.style.display = 'block';
      const el = document.createElement('div');
      el.style.color = color || 'var(--ca-muted)';
      el.textContent = msg;
      logEl.appendChild(el);
      logEl.scrollTop = logEl.scrollHeight;
    };

    if (!opts.silent) {
      if (!confirm('¿Recalcular puntos para TODOS los participantes?')) return;
      if (logEl) { logEl.innerHTML = ''; logEl.style.display = 'none'; }
    }

    log('📊 Cargando datos...', 'var(--ca-muted)');

    try {
      const [matchSnap, resultSnap, userSnap, pointsSnap] = await Promise.all([
        this.db.collection('matches').get(),
        this.db.collection('results').get(),
        this.db.collection('users').get(),
        this.db.doc('config/points').get()
      ]);

      const matches = {};
      matchSnap.forEach(d => { matches[d.id] = d.data(); });

      const results = {};
      resultSnap.forEach(d => { results[d.id] = d.data(); });

      // Orden CRONOLÓGICO real del torneo — NUNCA alfabético por ID. Las rachas de
      // aciertos consecutivos (y sus bonos +5/+15/+35/+70) dependen del orden real en
      // que se jugaron los partidos. Un sort() alfabético simple pondría, por ejemplo,
      // 'final_match' antes que cualquier partido de 'league_...' (f < l), y 'qf_...'
      // antes que 'r16_...' (q < r) — es decir, cuartos antes que octavos — arruinando
      // por completo el cálculo de racha. Mismo criterio que usa el usuario en
      // _renderMisStats (sr-champions.js) para su propia evolución de puntos.
      // Mismo criterio EXACTO que usa sr-champions.js (_renderMisStats) para que el
      // total recalculado aquí nunca pueda divergir de lo que el usuario ve de sí mismo.
      const PHASE_ORDER = ['league','playoff','r16','qf','sf','final'];
      // El partido de prueba (id fijo 'test_match') NUNCA debe afectar puntos reales,
      // sin importar en qué fase/jornada lo haya posicionado el admin para previsualizarlo
      // (ver CHAdmin.applyTestPosition) — se excluye siempre, de forma incondicional.
      const resultIds = Object.keys(results)
        .filter(id => id !== 'test_match')
        .sort((a, b) => {
          const ma = matches[a] || {}, mb = matches[b] || {};
          const pa = PHASE_ORDER.indexOf(ma.phase || 'league');
          const pb = PHASE_ORDER.indexOf(mb.phase || 'league');
          if (pa !== pb) return pa - pb;
          return ((ma.matchday || 0) * 100 + (ma.matchOrder || 0)) -
                 ((mb.matchday || 0) * 100 + (mb.matchOrder || 0));
        });
      log('✅ ' + resultIds.length + ' resultados · ' + Object.keys(matches).length + ' partidos', '#4ade80');

      if (resultIds.length === 0) {
        log('⚠️ No hay resultados guardados todavía.', '#f59e0b');
        return;
      }

      const pointsCfg = pointsSnap.exists ? pointsSnap.data() : null;
      const phaseMap  = this._resolvePoints(pointsCfg);
      const racha     = this._resolveRacha(pointsCfg);
      const getPts = id => {
        const m = matches[id];
        if (!m) return phaseMap.league;
        return phaseMap[m.phase || m.fase] || phaseMap.league;
      };

      const users = [];
      userSnap.forEach(d => users.push({ id: d.id, ...d.data() }));
      log('👥 Procesando ' + users.length + ' usuarios...', 'var(--ca-muted)');

      let processed = 0;
      // jornadaBoard acumula, por cada jornada de liga (1-8), los puntos que cada
      // usuario ganó SOLO con los partidos de esa jornada — sirve para el premio
      // semanal "Ganador de la Jornada" (camisola), independiente del ranking total.
      const jornadaBoard = {};
      for (const u of users) {
        const predSnap = await this.db.collection('users/' + u.id + '/ch_predictions').get();
        if (predSnap.empty) continue;

        const preds = {};
        predSnap.forEach(d => { preds[d.id] = d.data(); });

        let pts = 0, correctos = 0, exactos = 0, anotadores = 0;
        let streak = 0, maxStreak = 0;
        const jornadaPts = {}, jornadaCorrectos = {};

        resultIds.forEach(mid => {
          const res  = results[mid];
          const pred = preds[mid];
          const fp   = getPts(mid);
          if (!res || !pred) { if (res) streak = 0; return; }

          const ph = Number(pred.homeScore  != null ? pred.homeScore  : pred.localScore);
          const pa = Number(pred.awayScore  != null ? pred.awayScore  : pred.visitanteScore);
          const rh = Number(res.homeScore);
          const ra = Number(res.awayScore);
          if (isNaN(ph) || isNaN(pa) || isNaN(rh) || isNaN(ra)) return;

          const pr = ph > pa ? 'H' : ph < pa ? 'A' : 'D';
          const rr = rh > ra ? 'H' : rh < ra ? 'A' : 'D';
          const m  = matches[mid] || {};
          const jd = (m.phase === 'league' && m.matchday) ? String(m.matchday) : null;

          if (pr === rr) {
            let matchPts = fp.resultado;
            correctos++;
            streak++;
            if (ph === rh && pa === ra) { matchPts += fp.exacto; exactos++; }
            const pFirst = pred.firstScoringTeam;
            const rFirst = res.firstScoringTeam;
            if (pFirst && rFirst && pFirst === rFirst) { matchPts += fp.anotador; anotadores++; }
            racha.forEach(r => { if (streak === r.n) matchPts += r.bonus; });
            if (streak > maxStreak) maxStreak = streak;
            pts += matchPts;
            if (jd) {
              jornadaPts[jd] = (jornadaPts[jd] || 0) + matchPts;
              jornadaCorrectos[jd] = (jornadaCorrectos[jd] || 0) + 1;
            }
          } else {
            streak = 0;
          }
        });

        await this.db.doc('users/' + u.id + '/ch_profile/main').set({
          totalPoints: pts, correctos, exactos, anotadores,
          streak, maxStreak, jornadaPts,
          lastRecalc: firebase.firestore.FieldValue.serverTimestamp()
        }, { merge: true });

        const name = u.displayName || u.email || u.id;
        Object.keys(jornadaPts).forEach(jd => {
          (jornadaBoard[jd] = jornadaBoard[jd] || []).push({
            uid: u.id, name, pts: jornadaPts[jd], correctos: jornadaCorrectos[jd] || 0
          });
        });

        log('  ' + name + ' → ' + pts + ' pts (' + correctos + ' ✅, ' + exactos + ' 🎯)', pts > 0 ? '#4ade80' : 'var(--ca-muted)');
        processed++;
      }

      // Ganador de la Jornada (premio: camisola) — se recalcula cada vez que se
      // recalculan puntos (o sea, cada vez que el admin carga un resultado), así el
      // líder se actualiza en vivo. "decided" marca si YA se jugaron todos los
      // partidos de esa jornada (si no, es un líder provisorio, no el ganador final).
      const matchesByJornada = {};
      Object.keys(matches).forEach(mid => {
        const m = matches[mid];
        if (m.phase === 'league' && m.matchday) {
          (matchesByJornada[m.matchday] = matchesByJornada[m.matchday] || []).push(mid);
        }
      });
      const jornadaWinners = {};
      Object.keys(matchesByJornada).forEach(jd => {
        const ids = matchesByJornada[jd];
        const decided = ids.length > 0 && ids.every(mid => !!results[mid]);
        const board = (jornadaBoard[jd] || []).slice().sort((a, b) =>
          b.pts - a.pts || b.correctos - a.correctos || a.name.localeCompare(b.name)
        );
        if (board.length > 0 && board[0].pts > 0) {
          jornadaWinners[jd] = {
            uid: board[0].uid, name: board[0].name, pts: board[0].pts, decided
          };
        }
      });
      await this.db.doc('config/jornadaWinners').set({
        jornadas: jornadaWinners, updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      });

      log('─────────────────────', 'var(--ca-border)');
      log('✅ Recálculo completo: ' + processed + ' usuarios actualizados', '#4ade80');
      if (!opts.silent) this.toast('✅ Puntos actualizados: ' + processed + ' usuarios', 'success');
      this.renderStats();
      if (this._activeTab === 'usuarios') this.renderUsuarios();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      log('❌ Error: ' + (e.message || e.code), '#f87171');
      if (!opts.silent) this.toast('Error en recálculo. Revisá la consola.', 'error');
    }
  },

  /* ══════════════════════════════════════════════════
     TAB: USUARIOS
  ══════════════════════════════════════════════════ */
  async renderUsuarios() {
    const cont = document.getElementById('cha-usuarios-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px">Cargando...</div>';
    try {
      const userSnap = await this.db.collection('users').get();
      const users = [];
      const fetches = [];

      userSnap.forEach(doc => {
        fetches.push(
          this.db.doc('users/' + doc.id + '/ch_profile/main').get().then(ps => {
            const base = doc.data() || {};
            const prof = ps.exists ? ps.data() : {};
            users.push({
              id:        doc.id,
              name:      prof.displayName || base.displayName || base.email?.split('@')[0] || '—',
              username:  base.username || '',
              favoriteClub: base.favoriteClub || '',
              email:     base.email || '—',
              pts:       prof.totalPoints || 0,
              correctos: prof.correctos   || 0,
              exactos:   prof.exactos     || 0,
              anotadores: prof.anotadores || 0,
              maxStreak: prof.maxStreak   || 0,
              hasPred:   ps.exists,
              createdAt: base.createdAt && base.createdAt.toDate ? base.createdAt.toDate().toISOString() : (base.createdAt || null)
            });
          })
        );
      });
      await Promise.all(fetches);
      users.sort((a, b) => b.pts - a.pts);
      this._lastUsers = users;

      const total = users.length;
      const conPts = users.filter(u => u.pts > 0).length;

      let html =
        '<div class="ca-kpi-grid">' +
          '<div class="ca-kpi"><div class="ca-kpi-label">Total usuarios</div><div class="ca-kpi-value">' + total + '</div></div>' +
          '<div class="ca-kpi"><div class="ca-kpi-label">Con predicciones</div><div class="ca-kpi-value">' + conPts + '</div></div>' +
          (users[0] ? '<div class="ca-kpi"><div class="ca-kpi-label">Líder del ranking</div><div class="ca-kpi-value" style="font-size:16px;margin-top:4px">' + chaEsc(users[0].name) + '</div></div>' : '') +
          (users[0] ? '<div class="ca-kpi"><div class="ca-kpi-label">Puntos del líder</div><div class="ca-kpi-value">' + users[0].pts + '</div></div>' : '') +
        '</div>';

      if (total === 0) {
        html += '<div class="ca-empty"><div class="ca-empty-icon">👥</div>No hay participantes registrados.</div>';
        cont.innerHTML = html;
        return;
      }

      html +=
        '<div style="display:flex;gap:10px;align-items:center;margin-bottom:14px;flex-wrap:wrap">' +
          '<input type="search" id="cha-user-search" placeholder="🔍 Buscar por nombre o email…" ' +
            'oninput="CHAdmin._filterUsers(this.value)" class="cha-input" style="flex:1;min-width:200px">' +
          '<select id="cha-user-sort" onchange="CHAdmin._sortUsers(this.value)" class="cha-input" style="flex-shrink:0">' +
            '<option value="pts">Ordenar: Pts (mayor a menor)</option>' +
            '<option value="nombre">Ordenar: Nombre (A-Z)</option>' +
            '<option value="reciente">Ordenar: Más reciente primero</option>' +
          '</select>' +
          '<span id="cha-user-count" style="color:var(--ca-muted);font-size:12px;white-space:nowrap">' + total + ' participantes</span>' +
        '</div>';

      html += '<div style="overflow-x:auto;border-radius:12px;border:1px solid var(--ca-border)">' +
        '<table class="ca-table"><thead><tr>' +
          '<th>#</th><th>Usuario</th><th>Email</th>' +
          '<th>Pts</th><th>Aciertos</th><th>Exactos</th><th>Goles</th><th>Racha máx</th><th>Acciones</th>' +
        '</tr></thead><tbody id="cha-user-tbody">' + this._buildUserRows(users) + '</tbody></table>' +
        '<div id="cha-user-empty" style="display:none;padding:28px;text-align:center;color:var(--ca-muted);font-size:13px">' +
          '🔍 Ningún participante coincide con la búsqueda.' +
        '</div>' +
      '</div>';
      cont.innerHTML = html;
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      cont.innerHTML = '<div style="color:var(--ca-red);padding:20px">Error al cargar usuarios.</div>';
    }
  },

  _buildUserRows(users) {
    return users.map((u, i) => {
      // La posición/medalla siempre refleja el ranking real por puntos (this._lastUsers,
      // que nunca se reordena), sin importar el orden de visualización actual.
      const realPos = (this._lastUsers || users).findIndex(x => x.id === u.id) + 1;
      const pos   = realPos || (i + 1);
      const medal = pos === 1 ? '🥇' : pos === 2 ? '🥈' : pos === 3 ? '🥉' : pos;
      const searchVal = chaEsc((u.name + ' ' + u.username + ' ' + u.email).toLowerCase());
      return '<tr data-search="' + searchVal + '"' + (pos <= 3 ? ' style="background:rgba(255,20,100,.02)"' : '') + '>' +
        '<td style="font-family:\'Bebas Neue\',sans-serif;font-size:16px;color:var(--ca-muted)">' + medal + '</td>' +
        '<td>' +
          '<div style="font-weight:700;color:var(--ca-text);font-size:14px">' +
            (u.username ? '@' + chaEsc(u.username) : chaEsc(u.name)) +
          '</div>' +
          '<div style="font-size:11px;color:var(--ca-muted);margin-top:2px">' +
            chaEsc(u.name) +
            (u.favoriteClub ? ' &nbsp;·&nbsp; ' + chaEsc(u.favoriteClub) : '') +
          '</div>' +
        '</td>' +
        '<td style="font-size:11px;color:var(--ca-muted)">' + chaEsc(u.email) + '</td>' +
        '<td style="font-family:\'Bebas Neue\',sans-serif;font-size:20px;color:var(--ca-gold);font-variant-numeric:tabular-nums">' + u.pts + '</td>' +
        '<td style="color:#4ade80">' + u.correctos + '</td>' +
        '<td style="color:var(--ca-gold)">' + u.exactos + '</td>' +
        '<td style="color:#60a5fa">' + u.anotadores + '</td>' +
        '<td style="color:#f59e0b">' + u.maxStreak + '</td>' +
        '<td>' +
          '<div style="display:flex;gap:5px;justify-content:center">' +
            '<button onclick="CHAdmin.showUserPredictions(\'' + u.id + '\')" title="Ver / editar vaticinios" ' +
              'style="background:rgba(96,165,250,.08);border:1px solid rgba(96,165,250,.4);color:#60a5fa;min-width:40px;min-height:40px;border-radius:6px;cursor:pointer;font-size:13px">📋</button>' +
            '<button onclick="CHAdmin.resetPassword(\'' + u.id + '\')" title="Enviar email de reset de contraseña" ' +
              'style="background:rgba(96,165,250,.08);border:1px solid rgba(96,165,250,.4);color:#60a5fa;min-width:40px;min-height:40px;border-radius:6px;cursor:pointer;font-size:13px">📧</button>' +
            '<button onclick="CHAdmin.deleteUser(\'' + u.id + '\')" title="Eliminar participante" ' +
              'style="background:rgba(248,113,113,.08);border:1px solid rgba(248,113,113,.4);color:#f87171;min-width:40px;min-height:40px;border-radius:6px;cursor:pointer;font-size:13px">🗑️</button>' +
          '</div>' +
        '</td>' +
      '</tr>';
    }).join('');
  },

  _sortUsers(mode) {
    if (!this._lastUsers) return;
    const sorted = this._lastUsers.slice();
    if (mode === 'nombre') sorted.sort((a, b) => a.name.localeCompare(b.name));
    else if (mode === 'reciente') sorted.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
    else sorted.sort((a, b) => b.pts - a.pts);
    const tbody = document.getElementById('cha-user-tbody');
    if (tbody) tbody.innerHTML = this._buildUserRows(sorted);
    const search = document.getElementById('cha-user-search');
    if (search && search.value) this._filterUsers(search.value);
  },

  _filterUsers(query) {
    const q = (query || '').toLowerCase().trim();
    const rows = document.querySelectorAll('#cha-user-tbody tr[data-search]');
    let visible = 0;
    rows.forEach(row => {
      const match = !q || row.dataset.search.includes(q);
      row.style.display = match ? '' : 'none';
      if (match) visible++;
    });
    const countEl = document.getElementById('cha-user-count');
    const emptyEl = document.getElementById('cha-user-empty');
    if (countEl) countEl.textContent = q ? visible + ' de ' + rows.length + ' participantes' : rows.length + ' participantes';
    if (emptyEl) emptyEl.style.display = (visible === 0) ? 'block' : 'none';
  },

  /* ── Exportar participantes a CSV ─────────────────────
     Usa los mismos datos ya cargados por renderUsuarios() (this._lastUsers) en
     vez de volver a consultar Firestore — es exactamente lo que el admin está
     viendo en pantalla en ese momento. ── */
  exportUsersCSV() {
    const users = this._lastUsers;
    if (!users || users.length === 0) {
      this.toast('No hay participantes para exportar todavía', 'error');
      return;
    }
    const escCsv = v => {
      const s = String(v == null ? '' : v);
      return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    };
    const header = ['Posición', 'Usuario', 'Nombre', 'Equipo favorito', 'Email', 'Puntos', 'Aciertos', 'Exactos', 'Goles', 'Racha máx'];
    const rows = users.map((u, i) => [
      i + 1, u.username || '', u.name || '', u.favoriteClub || '', u.email || '',
      u.pts || 0, u.correctos || 0, u.exactos || 0, u.anotadores || 0, u.maxStreak || 0
    ]);
    const csv = '﻿' + [header, ...rows].map(r => r.map(escCsv).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'champions-participantes-' + new Date().toISOString().slice(0, 10) + '.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    this.toast('📥 CSV descargado (' + users.length + ' participantes)', 'success');
  },

  /* ══════════════════════════════════════════════════
     TAB: ANALÍTICAS
     Participación real + exposición de sponsors/banners — pensado para poder
     mostrárselo directo a una marca al negociar un patrocinio.
  ══════════════════════════════════════════════════ */
  async renderAnaliticas() {
    const cont = document.getElementById('cha-analiticas-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px">Cargando...</div>';
    try {
      const [matchesSnap, usersSnap, sponsorsSnap, bannersSnap] = await Promise.all([
        this.db.collection('matches').get(),
        this.db.collection('users').get(),
        this.db.collection('champions_sponsors').get(),
        this.db.collection('champions_banners').get()
      ]);

      const matches = [];
      matchesSnap.forEach(d => { if (d.id !== 'test_match') matches.push({ id: d.id, ...d.data() }); });
      const totalUsers = usersSnap.size;

      // Predicciones por partido, leyendo la subcolección de cada usuario en paralelo
      const predCounts = {};
      let usersWithAnyPred = 0;
      await Promise.all(usersSnap.docs.map(u =>
        this.db.collection('users/' + u.id + '/ch_predictions').get().then(snap => {
          if (snap.size > 0) usersWithAnyPred++;
          snap.forEach(p => {
            if (p.id === 'test_match') return;
            predCounts[p.id] = (predCounts[p.id] || 0) + 1;
          });
        }).catch(() => {})
      ));

      const byJornada = {};
      matches.forEach(m => {
        if (m.phase !== 'league' || !m.matchday) return;
        if (!byJornada[m.matchday]) byJornada[m.matchday] = { matches: 0, preds: 0 };
        byJornada[m.matchday].matches++;
        byJornada[m.matchday].preds += (predCounts[m.id] || 0);
      });
      const jornadaRows = Object.keys(byJornada).sort((a, b) => a - b).map(j => {
        const d = byJornada[j];
        const maxPosible = d.matches * totalUsers;
        const pct = maxPosible > 0 ? Math.round((d.preds / maxPosible) * 100) : 0;
        return { jornada: j, preds: d.preds, maxPosible, pct };
      });

      const sponsors = [];
      sponsorsSnap.forEach(d => sponsors.push({ id: d.id, ...d.data() }));
      sponsors.sort((a, b) => (b.clicks || 0) - (a.clicks || 0));

      const banners = [];
      bannersSnap.forEach(d => banners.push({ id: d.id, ...d.data() }));
      banners.sort((a, b) => (b.clicks || 0) - (a.clicks || 0));

      const participRate = totalUsers > 0 ? Math.round((usersWithAnyPred / totalUsers) * 100) : 0;

      let html = '<div class="ca-kpi-grid">' +
        '<div class="ca-kpi"><div class="ca-kpi-label">Participantes</div><div class="ca-kpi-value">' + totalUsers + '</div></div>' +
        '<div class="ca-kpi"><div class="ca-kpi-label">Con al menos 1 predicción</div><div class="ca-kpi-value">' + usersWithAnyPred + '</div></div>' +
        '<div class="ca-kpi"><div class="ca-kpi-label">Tasa de participación</div><div class="ca-kpi-value">' + participRate + '%</div></div>' +
      '</div>';

      html += '<div class="cha-card" style="margin-top:18px">' +
        '<div style="font-size:13px;font-weight:700;color:var(--ca-text);margin-bottom:14px">⚽ Participación por jornada (Fase de Liga)</div>';
      if (jornadaRows.length === 0) {
        html += '<div style="color:var(--ca-muted);font-size:13px">Todavía no hay partidos de liga cargados.</div>';
      } else {
        jornadaRows.forEach(r => {
          html += '<div style="display:flex;align-items:center;gap:12px;padding:8px 0;border-bottom:1px solid var(--ca-border)">' +
            '<span style="width:80px;font-size:12px;color:var(--ca-muted);flex-shrink:0">Jornada ' + r.jornada + '</span>' +
            '<div style="flex:1;height:8px;background:var(--ca-raised);border-radius:4px;overflow:hidden">' +
              '<div style="height:100%;width:' + r.pct + '%;background:linear-gradient(90deg,#FF1464,#9B5DFF);border-radius:4px"></div>' +
            '</div>' +
            '<span style="width:120px;text-align:right;font-size:12px;color:var(--ca-text);flex-shrink:0">' + r.preds + '/' + r.maxPosible + ' (' + r.pct + '%)</span>' +
          '</div>';
        });
      }
      html += '</div>';

      html += '<div class="cha-card" style="margin-top:18px">' +
        '<div style="font-size:13px;font-weight:700;color:var(--ca-text);margin-bottom:14px">📢 Clics en sponsors</div>';
      if (sponsors.length === 0) {
        html += '<div style="color:var(--ca-muted);font-size:13px">No hay sponsors cargados todavía.</div>';
      } else {
        sponsors.forEach(s => {
          html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:8px 0;border-bottom:1px solid var(--ca-border)">' +
            '<span style="font-size:13px;color:var(--ca-text)">' + chaEsc(s.name || s.id) + '</span>' +
            '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:16px;color:var(--ca-gold)">' + (s.clicks || 0) + '</span>' +
          '</div>';
        });
      }
      html += '</div>';

      html += '<div class="cha-card" style="margin-top:18px">' +
        '<div style="font-size:13px;font-weight:700;color:var(--ca-text);margin-bottom:14px">🖼️ Clics en banners de producto</div>';
      if (banners.length === 0) {
        html += '<div style="color:var(--ca-muted);font-size:13px">No hay banners cargados todavía.</div>';
      } else {
        banners.forEach(b => {
          html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:8px 0;border-bottom:1px solid var(--ca-border)">' +
            '<span style="font-size:13px;color:var(--ca-text)">' + chaEsc(b.title || 'Banner sin título') + '</span>' +
            '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:16px;color:var(--ca-gold)">' + (b.clicks || 0) + '</span>' +
          '</div>';
        });
      }
      html += '</div>';

      cont.innerHTML = html;
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      cont.innerHTML = '<div style="color:var(--ca-red);padding:20px">Error al cargar analíticas.</div>';
    }
  },

  /* ══════════════════════════════════════════════════
     TAB: SALÓN DE LA FAMA
  ══════════════════════════════════════════════════ */
  async renderFama() {
    const cont = document.getElementById('cha-fama-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px">Cargando...</div>';
    try {
      const snap = await this.db.collection('champions_halloffame').get();
      const entries = [];
      snap.forEach(d => entries.push({ id: d.id, ...d.data() }));
      entries.sort((a, b) => (a.order || 0) - (b.order || 0));

      let html = this._famaNewForm();
      if (entries.length === 0) {
        html += '<div class="ca-empty"><div class="ca-empty-icon">🏛️</div>Sin entradas todavía. Agregá el campeón de una temporada anterior arriba.</div>';
      } else {
        entries.forEach((f, i) => { html += this._famaRow(f, i, entries.length); });
      }
      cont.innerHTML = html;
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      cont.innerHTML = '<div style="color:var(--ca-red);padding:20px">Error al cargar el Salón de la Fama.</div>';
    }
  },

  _famaNewForm() {
    return '<div class="cha-card" style="margin-bottom:14px;border-color:rgba(255,20,100,.3)">' +
      '<div style="font-size:11px;color:var(--ca-gold);letter-spacing:1px;margin-bottom:10px">+ AGREGAR ENTRADA</div>' +
      '<div style="display:grid;grid-template-columns:70px 1fr 1fr;gap:10px;margin-bottom:10px">' +
        '<input class="cha-input" id="fama-new-icon" placeholder="🏆" maxlength="8" title="Emoji">' +
        '<input class="cha-input" id="fama-new-season" placeholder="Ej: Mundial 2026 · Playoffs">' +
        '<input class="cha-input" id="fama-new-achievement" placeholder="Ej: Campeón">' +
      '</div>' +
      '<div style="display:grid;grid-template-columns:1fr 140px auto;gap:10px">' +
        '<input class="cha-input" id="fama-new-name" placeholder="Nombre del participante">' +
        '<input class="cha-input" id="fama-new-points" type="number" min="0" placeholder="Puntos">' +
        '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.addFamaEntry()">+ Agregar</button>' +
      '</div>' +
    '</div>';
  },

  _famaRow(f, i, total) {
    return '<div class="cha-card" style="margin-bottom:10px;display:flex;align-items:center;gap:14px;flex-wrap:wrap">' +
      '<span style="font-size:28px;flex-shrink:0">' + chaEsc(f.icon || '🏆') + '</span>' +
      '<div style="flex:1;min-width:180px">' +
        '<div style="font-size:10px;letter-spacing:1.5px;text-transform:uppercase;color:var(--ca-muted)">' + chaEsc(f.season || '') + '</div>' +
        '<div style="font-size:14px;font-weight:700;color:var(--ca-text)">' + chaEsc(f.participantName || '') + '</div>' +
        '<div style="font-size:12px;color:var(--ca-gold)">' + chaEsc(f.achievement || '') + (f.points ? ' · ' + f.points + ' pts' : '') + '</div>' +
      '</div>' +
      '<div style="display:flex;gap:6px;flex-shrink:0">' +
        '<button class="cha-btn cha-btn-sm" onclick="CHAdmin.moveFamaEntry(\'' + f.id + '\',-1)"' + (i === 0 ? ' disabled' : '') + '>↑</button>' +
        '<button class="cha-btn cha-btn-sm" onclick="CHAdmin.moveFamaEntry(\'' + f.id + '\',1)"' + (i === total - 1 ? ' disabled' : '') + '>↓</button>' +
        '<button class="cha-btn cha-btn-danger cha-btn-sm" onclick="CHAdmin.removeFamaEntry(\'' + f.id + '\')">🗑️</button>' +
      '</div>' +
    '</div>';
  },

  async addFamaEntry() {
    const icon = document.getElementById('fama-new-icon')?.value.trim() || '🏆';
    const season = document.getElementById('fama-new-season')?.value.trim();
    const achievement = document.getElementById('fama-new-achievement')?.value.trim();
    const participantName = document.getElementById('fama-new-name')?.value.trim();
    const points = parseInt(document.getElementById('fama-new-points')?.value, 10) || 0;
    if (!season || !achievement || !participantName) {
      return this.toast('Completá temporada, logro y nombre', 'error');
    }
    try {
      const existingSnap = await this.db.collection('champions_halloffame').get();
      await this.db.collection('champions_halloffame').add({
        icon, season, achievement, participantName, points,
        order: existingSnap.size, createdAt: firebase.firestore.FieldValue.serverTimestamp()
      });
      this.toast('✅ Agregado al Salón de la Fama', 'success');
      this.renderFama();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al agregar.', 'error');
    }
  },

  async removeFamaEntry(id) {
    if (!confirm('¿Eliminar esta entrada del Salón de la Fama?')) return;
    try {
      await this.db.collection('champions_halloffame').doc(id).delete();
      this.toast('Eliminado', 'success');
      this.renderFama();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al eliminar.', 'error');
    }
  },

  async moveFamaEntry(id, dir) {
    try {
      const snap = await this.db.collection('champions_halloffame').get();
      const entries = [];
      snap.forEach(d => entries.push({ id: d.id, order: d.data().order || 0 }));
      entries.sort((a, b) => a.order - b.order);
      const idx = entries.findIndex(e => e.id === id);
      const swapIdx = idx + dir;
      if (idx === -1 || swapIdx < 0 || swapIdx >= entries.length) return;
      const batch = this.db.batch();
      batch.update(this.db.collection('champions_halloffame').doc(entries[idx].id), { order: entries[swapIdx].order });
      batch.update(this.db.collection('champions_halloffame').doc(entries[swapIdx].id), { order: entries[idx].order });
      await batch.commit();
      this.renderFama();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al reordenar.', 'error');
    }
  },

  /* ── Ver / editar vaticinios + reset password + eliminar ── */

  async showUserPredictions(userId) {
    const existing = document.getElementById('cha-preds-modal');
    if (existing) existing.remove();

    const modal = document.createElement('div');
    modal.id = 'cha-preds-modal';
    modal.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.88);' +
      'z-index:9999;overflow-y:auto;padding:16px;box-sizing:border-box';
    modal.addEventListener('click', e => { if (e.target === modal) CHAdmin._closePredModal(); });

    const box = document.createElement('div');
    box.style.cssText = 'max-width:960px;margin:0 auto;background:var(--ca-card);border-radius:12px;padding:24px';
    box.innerHTML = '<p style="color:var(--ca-muted);padding:40px 0;text-align:center">Cargando predicciones…</p>';
    modal.appendChild(box);
    document.body.appendChild(modal);

    try {
      const [userDoc, predsSnap, qualsSnap, matchSnap, resultSnap, pointsSnap] = await Promise.all([
        this.db.doc('users/' + userId).get(),
        this.db.collection('users/' + userId + '/ch_predictions').get(),
        this.db.collection('users/' + userId + '/ch_qualifiers').get(),
        this.db.collection('matches').get(),
        this.db.collection('results').get(),
        this.db.doc('config/points').get()
      ]);

      if (!userDoc.exists) {
        box.innerHTML = '<p style="color:var(--ca-red);padding:20px">Usuario no encontrado.</p>' + this._predModalCloseBtn();
        return;
      }

      const user   = userDoc.data();
      const uname  = chaEsc(user.displayName || user.email || userId);
      const matches = {}; matchSnap.forEach(d => { matches[d.id] = d.data(); });
      const results = {}; resultSnap.forEach(d => { results[d.id] = d.data(); });
      const preds  = {};  predsSnap.forEach(d => { preds[d.id] = d.data(); });
      const quals  = {};  qualsSnap.forEach(d => { quals[d.id] = d.data(); });
      const phaseMap = this._resolvePoints(pointsSnap.exists ? pointsSnap.data() : null);

      // Ordenar cronológicamente (liga por jornada/orden, luego eliminatorias)
      const matchIds = Object.keys(matches).filter(id => id !== 'test_match').sort((a, b) => {
        const PHASE_ORDER = ['league','playoff','r16','qf','sf','final'];
        const ma = matches[a], mb = matches[b];
        const pa = PHASE_ORDER.indexOf(ma.phase || 'league'), pb = PHASE_ORDER.indexOf(mb.phase || 'league');
        if (pa !== pb) return pa - pb;
        return ((ma.matchday || 0) * 100 + (ma.matchOrder || 0)) - ((mb.matchday || 0) * 100 + (mb.matchOrder || 0));
      });

      let body = '<div style="font-size:10px;letter-spacing:2px;color:var(--ca-gold);font-weight:700;margin:0 0 10px">⚽ VATICINIOS DE PARTIDOS</div>';
      matchIds.forEach(mid => {
        const m = matches[mid], pred = preds[mid] || null, result = results[mid] || null;
        const fp = phaseMap[m.phase || 'league'] || phaseMap.league;
        let ptsEarned = null;
        if (pred && result) {
          const ph = Number(pred.homeScore), pa = Number(pred.awayScore);
          const rh = Number(result.homeScore), ra = Number(result.awayScore);
          if (!isNaN(ph) && !isNaN(pa) && !isNaN(rh) && !isNaN(ra)) {
            const pr = ph > pa ? 'H' : ph < pa ? 'A' : 'D', rr = rh > ra ? 'H' : rh < ra ? 'A' : 'D';
            ptsEarned = 0;
            if (pr === rr) {
              ptsEarned += fp.resultado;
              if (ph === rh && pa === ra) ptsEarned += fp.exacto;
              if (pred.firstScoringTeam && result.firstScoringTeam && pred.firstScoringTeam === result.firstScoringTeam) ptsEarned += fp.anotador;
            }
          }
        }
        const hasPred = !!pred;
        body += '<div style="background:rgba(255,255,255,.02);border:1px solid ' + (hasPred ? 'rgba(255,20,100,.3)' : 'var(--ca-border)') + ';border-radius:8px;padding:12px 14px;margin-bottom:8px">' +
          '<div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:8px;margin-bottom:10px">' +
            '<div>' +
              '<span style="font-size:13px;font-weight:600;color:var(--ca-text)">' + chaEsc(m.homeTeamName || '?') + ' <span style="color:var(--ca-muted);font-weight:400">vs</span> ' + chaEsc(m.awayTeamName || '?') + '</span>' +
              '<div style="font-size:10px;color:var(--ca-muted);margin-top:2px">' + chaEsc(mid) + '</div>' +
            '</div>' +
            '<div style="display:flex;align-items:center;gap:8px">' +
              (result
                ? '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:18px;color:var(--ca-gold)">' + result.homeScore + '–' + result.awayScore + '</span>' +
                  (ptsEarned !== null ? '<span style="padding:2px 8px;border-radius:12px;font-size:11px;font-weight:700;background:' + (ptsEarned > 0 ? 'rgba(74,222,128,.1)' : 'rgba(248,113,113,.1)') + ';color:' + (ptsEarned > 0 ? '#4ade80' : '#f87171') + '">' + (ptsEarned > 0 ? '+' + ptsEarned + ' pts' : '0 pts') + '</span>' : '')
                : '<span style="font-size:10px;color:var(--ca-muted);font-style:italic">Sin resultado</span>') +
            '</div>' +
          '</div>' +
          '<form onsubmit="CHAdmin.editUserPrediction(event,\'' + userId + '\',\'' + mid + '\')" style="display:flex;gap:8px;align-items:flex-end;flex-wrap:wrap">' +
            '<div><label class="cha-label">' + chaEsc((m.homeTeamName || 'LOCAL').slice(0,8).toUpperCase()) + '</label>' +
              '<input class="cha-input" type="number" name="homeScore" min="0" max="30" required value="' + (hasPred ? Number(pred.homeScore) : '') + '" style="width:60px;text-align:center"></div>' +
            '<span style="padding-bottom:10px;color:var(--ca-muted)">—</span>' +
            '<div><label class="cha-label">' + chaEsc((m.awayTeamName || 'VISIT').slice(0,8).toUpperCase()) + '</label>' +
              '<input class="cha-input" type="number" name="awayScore" min="0" max="30" required value="' + (hasPred ? Number(pred.awayScore) : '') + '" style="width:60px;text-align:center"></div>' +
            '<div><label class="cha-label">PRIMER GOL</label>' +
              '<select name="firstScoringTeam" class="cha-input" style="font-size:12px">' +
                '<option value="home"' + (pred && pred.firstScoringTeam === 'home' ? ' selected' : '') + '>' + chaEsc(m.homeTeamName || 'Local') + '</option>' +
                '<option value="none"' + (!pred || !pred.firstScoringTeam || pred.firstScoringTeam === 'none' ? ' selected' : '') + '>Sin goles</option>' +
                '<option value="away"' + (pred && pred.firstScoringTeam === 'away' ? ' selected' : '') + '>' + chaEsc(m.awayTeamName || 'Visitante') + '</option>' +
              '</select></div>' +
            '<button type="submit" class="cha-btn cha-btn-gold" style="padding:8px 14px;font-size:12px">' + (hasPred ? '💾 Guardar' : '✏️ Crear') + '</button>' +
          '</form>' +
        '</div>';
      });

      // Sección de llaves eliminatorias (a quién eligió avanzar)
      const qualKeys = Object.keys(quals);
      if (qualKeys.length > 0) {
        body += '<div style="font-size:10px;letter-spacing:2px;color:var(--ca-gold);font-weight:700;margin:20px 0 10px">🏆 A QUIÉN ELIGIÓ QUE AVANCE</div>';
        qualKeys.forEach(tieId => {
          const q = quals[tieId];
          body += '<div style="background:rgba(255,255,255,.02);border:1px solid var(--ca-border);border-radius:8px;padding:10px 14px;margin-bottom:6px;display:flex;justify-content:space-between;align-items:center">' +
            '<span style="font-size:12px;color:var(--ca-muted)">' + chaEsc(tieId) + '</span>' +
            '<span style="font-size:13px;font-weight:600;color:var(--ca-text)">' + chaEsc(q.qualifiedTeamName || q.qualifiedTeamId || '—') + '</span>' +
          '</div>';
        });
      }

      box.innerHTML =
        '<div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:12px;margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid var(--ca-border)">' +
          '<div>' +
            '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:24px;color:var(--ca-gold);letter-spacing:2px">VATICINIOS — ' + uname + '</div>' +
            '<div style="font-size:12px;color:var(--ca-muted);margin-top:4px">' + chaEsc(user.email || '') + ' · <strong>' + Object.keys(preds).length + ' predicciones</strong></div>' +
          '</div>' +
          this._predModalCloseBtn() +
        '</div>' +
        body +
        '<div style="margin-top:20px;padding-top:14px;border-top:1px solid var(--ca-border);text-align:right">' + this._predModalCloseBtn() + '</div>';

    } catch(e) {
      if (this.isSessionError(e)) { this._closePredModal(); return this.handleSessionErr(); }
      box.innerHTML = '<p style="color:var(--ca-red);padding:20px">Error al cargar las predicciones.</p>' + this._predModalCloseBtn();
    }
  },

  async editUserPrediction(e, userId, matchId) {
    e.preventDefault();
    const form = e.target;
    const homeScore = parseInt(form.querySelector('[name="homeScore"]').value, 10);
    const awayScore  = parseInt(form.querySelector('[name="awayScore"]').value, 10);
    const firstScoringTeam = form.querySelector('[name="firstScoringTeam"]').value || 'none';

    if (isNaN(homeScore) || isNaN(awayScore)) return this.toast('Ingresá marcadores válidos', 'error');
    if (homeScore < 0 || homeScore > 30 || awayScore < 0 || awayScore > 30) return this.toast('El marcador debe estar entre 0 y 30', 'error');

    const btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Guardando…'; }

    try {
      await this.db.doc('users/' + userId + '/ch_predictions/' + matchId).set({
        homeScore, awayScore, firstScoringTeam,
        savedAt: firebase.firestore.FieldValue.serverTimestamp(),
        editedByAdmin: true
      }, { merge: true });
      this.toast('✅ Vaticinio actualizado', 'success');
      await this.showUserPredictions(userId);
      // Sin esto, este cambio nunca se reflejaría en ch_profile/main (Champions
      // persiste los totales, no los calcula en vivo como Mundial).
      await this.recalcularPuntos({ silent: true });
    } catch(e) {
      if (btn) { btn.disabled = false; btn.textContent = '💾 Guardar'; }
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar.', 'error');
    }
  },

  _closePredModal() {
    const m = document.getElementById('cha-preds-modal');
    if (m) m.remove();
  },

  _predModalCloseBtn() {
    return '<button onclick="CHAdmin._closePredModal()" style="background:rgba(255,255,255,.05);color:var(--ca-text);' +
      'border:1px solid var(--ca-border2);padding:8px 16px;border-radius:8px;cursor:pointer;font-size:12px">✕ Cerrar</button>';
  },

  async resetPassword(userId) {
    try {
      const doc = await this.db.doc('users/' + userId).get();
      if (!doc.exists) return this.toast('Usuario no encontrado', 'error');
      const user = doc.data();
      if (!confirm('¿Enviar correo de restablecimiento de contraseña a ' + (user.displayName || '') + ' (' + user.email + ')?')) return;
      await this.auth.sendPasswordResetEmail(user.email);
      this.toast('📧 Correo de restablecimiento enviado a ' + user.email, 'success');
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al enviar el correo.', 'error');
    }
  },

  // Firestore no borra subcolecciones en cascada al borrar el doc padre — hay que
  // enumerar y borrar cada doc de ch_predictions/ch_qualifiers uno por uno.
  // Champions no tiene función de grupos/amigos (a diferencia de Mundial), así que
  // no aplica ninguna limpieza adicional de ese tipo.
  async deleteUser(userId) {
    if (!confirm('¿Eliminar este participante y todas sus predicciones? Su cuenta de acceso (login) seguirá existiendo en Firebase Authentication — bórrala manualmente desde la consola de Firebase si querés liberar ese email.')) return;
    try {
      const [predsSnap, qualsSnap] = await Promise.all([
        this.db.collection('users/' + userId + '/ch_predictions').get(),
        this.db.collection('users/' + userId + '/ch_qualifiers').get()
      ]);
      const batch = this.db.batch();
      batch.delete(this.db.doc('users/' + userId));
      batch.delete(this.db.doc('users/' + userId + '/ch_profile/main'));
      predsSnap.forEach(d => batch.delete(d.ref));
      qualsSnap.forEach(d => batch.delete(d.ref));
      await batch.commit();
      this.toast('Participante eliminado', 'warning');
      this.renderUsuarios();
      this.renderStats();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al eliminar.', 'error');
    }
  },

  /* ══════════════════════════════════════════════════
     TAB: PREMIOS — Termómetro personalizable
  ══════════════════════════════════════════════════ */
  async renderPremios() {
    const cont = document.getElementById('cha-premios-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px">Cargando premios...</div>';
    try {
      const snap = await this.db.doc('config/prizes').get();
      this._prizeLevels = (snap.exists && Array.isArray(snap.data().levels))
        ? snap.data().levels.slice().sort((a, b) => (a.pts || 0) - (b.pts || 0))
        : [];
      this._renderPremiosUI(cont);
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      cont.innerHTML = '<div style="color:var(--ca-red);padding:20px">Error al cargar premios.</div>';
    }
  },

  _renderPremiosUI(cont) {
    const levels = this._prizeLevels;
    let html =
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px">' +
        '<div style="font-size:11px;letter-spacing:2px;color:var(--ca-gold);font-weight:700">🎁 PREMIOS DEL TERMÓMETRO</div>' +
        '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.showAddPrize()" style="font-size:12px;padding:7px 16px">+ AGREGAR</button>' +
      '</div>' +
      '<div id="cha-prize-add-form" style="display:none;margin-bottom:12px"></div>';

    if (levels.length === 0) {
      html +=
        '<div class="cha-card" style="text-align:center;padding:28px;color:var(--ca-muted)">' +
          '<div style="font-size:36px;margin-bottom:8px">🎯</div>' +
          '<div>No hay premios todavía. Agregá el primero con el botón de arriba.</div>' +
        '</div>';
    } else {
      html += '<div id="cha-prize-list">';
      levels.forEach(p => { html += this._prizeRow(p); });
      html += '</div>';
    }

    cont.innerHTML = html;
  },

  _prizeRow(prize) {
    const id = chaEsc(prize.id || '');
    const hasSponsor = !!(prize.sponsorName || prize.sponsorLogo);
    return '<div class="cha-card" id="cha-prize-row-' + id + '" style="margin-bottom:10px;padding:14px 16px">' +
      '<div style="display:flex;align-items:center;gap:10px">' +
        '<span style="font-size:24px;line-height:1;flex-shrink:0">' + chaEsc(prize.icon || '🏆') + '</span>' +
        '<div style="flex:1;min-width:0">' +
          '<div style="font-size:13px;font-weight:700;color:var(--ca-text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + chaEsc(prize.title || '—') + '</div>' +
          '<div style="font-size:11px;color:var(--ca-gold);font-weight:700;margin-top:2px">' + (prize.pts || 0) + ' puntos</div>' +
        '</div>' +
        '<button class="cha-btn" onclick="CHAdmin.editPrize(\'' + id + '\')" style="padding:5px 12px;font-size:11px;flex-shrink:0">✏️ EDITAR</button>' +
        '<button class="cha-btn" onclick="CHAdmin.confirmDeletePrize(\'' + id + '\')" style="padding:5px 12px;font-size:11px;color:var(--ca-red);border-color:rgba(255,80,60,.3);flex-shrink:0">🗑️</button>' +
      '</div>' +
      (hasSponsor ?
        '<div style="margin-top:10px;padding:8px 12px;background:rgba(255,20,100,.04);border:1px solid rgba(255,20,100,.1);border-radius:8px;display:flex;align-items:center;gap:10px">' +
          '<span style="font-size:7px;letter-spacing:2px;color:rgba(155,170,204,.4);font-weight:700;white-space:nowrap">PATROCINADO POR</span>' +
          (prize.sponsorLogo
            ? '<img src="' + prize.sponsorLogo + '" style="height:28px;max-width:100px;object-fit:contain">'
            : '<span style="font-size:12px;font-weight:700;color:rgba(255,255,255,.6)">' + chaEsc(prize.sponsorName || '') + '</span>'
          ) +
        '</div>'
        : ''
      ) +
      '<div id="cha-prize-edit-' + id + '" style="display:none;margin-top:12px"></div>' +
    '</div>';
  },

  _prizeForm(prize, isNew) {
    const fid = prize ? chaEsc(prize.id) : '__new__';
    const hasLogo = !!(prize && prize.sponsorLogo);
    const submitFn = isNew ? 'CHAdmin.saveNewPrize()' : ('CHAdmin.savePrize(\'' + fid + '\')');
    const cancelFn = isNew ? 'CHAdmin.cancelAddPrize()' : ('CHAdmin.cancelEditPrize(\'' + fid + '\')');
    return '<div style="padding:14px;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:10px">' +
      '<div style="display:grid;grid-template-columns:80px 60px 1fr;gap:10px;margin-bottom:10px">' +
        '<div>' +
          '<label class="cha-label">Puntos</label>' +
          '<input id="pf-pts-' + fid + '" type="number" min="1" placeholder="100" class="cha-input" style="text-align:center" value="' + chaEsc(String(prize ? prize.pts || '' : '')) + '">' +
        '</div>' +
        '<div>' +
          '<label class="cha-label">Icono</label>' +
          '<input id="pf-icon-' + fid + '" type="text" maxlength="4" placeholder="🏆" class="cha-input" style="font-size:20px;text-align:center;padding:4px" value="' + chaEsc(prize ? prize.icon || '🏆' : '🏆') + '">' +
        '</div>' +
        '<div>' +
          '<label class="cha-label">Título del premio</label>' +
          '<input id="pf-title-' + fid + '" type="text" placeholder="Ej: Camiseta Champions" class="cha-input" value="' + chaEsc(prize ? prize.title || '' : '') + '">' +
        '</div>' +
      '</div>' +
      '<div style="border-top:1px solid rgba(255,255,255,.06);margin:10px 0 8px;padding-top:10px">' +
        '<div style="font-size:8px;letter-spacing:2px;color:rgba(155,170,204,.4);font-weight:700;margin-bottom:8px">PATROCINADOR (OPCIONAL)</div>' +
        '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:8px">' +
          '<div>' +
            '<label class="cha-label">Nombre del patrocinador</label>' +
            '<input id="pf-spname-' + fid + '" type="text" placeholder="Nombre del sponsor" class="cha-input" value="' + chaEsc(prize ? prize.sponsorName || '' : '') + '">' +
          '</div>' +
          '<div>' +
            '<label class="cha-label">Sitio web (opcional)</label>' +
            '<input id="pf-spurl-' + fid + '" type="url" placeholder="https://sitio-del-sponsor.com" class="cha-input" value="' + chaEsc(prize ? prize.sponsorUrl || '' : '') + '">' +
          '</div>' +
        '</div>' +
        '<div style="margin-bottom:8px">' +
          '<label class="cha-label">Logo del patrocinador</label>' +
          '<input type="file" accept="image/*" onchange="CHAdmin.previewPrizeLogo(this,\'' + fid + '\')" class="cha-input" style="padding:6px;font-size:11px">' +
          '<input type="hidden" id="prize-logo-data-' + fid + '" value="' + (prize && prize.sponsorLogo ? chaEsc(prize.sponsorLogo) : '') + '">' +
          (prize && prize.clicks ? '<span style="font-size:10px;color:var(--ca-muted);margin-left:8px">👆 ' + prize.clicks + ' clics</span>' : '') +
        '</div>' +
        '<div id="prize-logo-preview-' + fid + '" style="text-align:center;min-height:20px">' +
          (hasLogo
            ? '<img src="' + prize.sponsorLogo + '" style="height:36px;max-width:130px;object-fit:contain;border-radius:6px;background:rgba(255,255,255,.04);padding:4px">' +
              '<div><button type="button" onclick="CHAdmin.clearPrizeLogo(\'' + fid + '\')" style="font-size:10px;color:var(--ca-red);background:none;border:none;cursor:pointer;margin-top:4px">✕ Quitar logo</button></div>'
            : '<div style="font-size:10px;color:rgba(155,170,204,.3)">Sin logo</div>'
          ) +
        '</div>' +
      '</div>' +
      '<div style="display:flex;gap:8px;margin-top:10px">' +
        '<button type="button" class="cha-btn cha-btn-gold" onclick="' + submitFn + '" style="flex:1;padding:9px">💾 GUARDAR PREMIO</button>' +
        '<button type="button" class="cha-btn" onclick="' + cancelFn + '" style="padding:9px 14px">Cancelar</button>' +
      '</div>' +
    '</div>';
  },

  showAddPrize() {
    // Close any open edit forms
    document.querySelectorAll('[id^="cha-prize-edit-"]').forEach(el => { el.style.display = 'none'; el.innerHTML = ''; });
    const formEl = document.getElementById('cha-prize-add-form');
    if (!formEl) return;
    // Toggle: if already visible, close it
    if (formEl.style.display === 'block') { formEl.style.display = 'none'; formEl.innerHTML = ''; return; }
    formEl.style.display = 'block';
    formEl.innerHTML = this._prizeForm(null, true);
    formEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  },

  cancelAddPrize() {
    const el = document.getElementById('cha-prize-add-form');
    if (el) { el.style.display = 'none'; el.innerHTML = ''; }
  },

  editPrize(id) {
    // Close add form and all other edit forms
    const addForm = document.getElementById('cha-prize-add-form');
    if (addForm) { addForm.style.display = 'none'; addForm.innerHTML = ''; }
    document.querySelectorAll('[id^="cha-prize-edit-"]').forEach(el => { el.style.display = 'none'; el.innerHTML = ''; });
    const prize = this._prizeLevels.find(p => chaEsc(p.id) === id);
    if (!prize) return;
    const editEl = document.getElementById('cha-prize-edit-' + id);
    if (!editEl) return;
    editEl.style.display = 'block';
    editEl.innerHTML = this._prizeForm(prize, false);
    editEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  },

  cancelEditPrize(id) {
    const el = document.getElementById('cha-prize-edit-' + id);
    if (el) { el.style.display = 'none'; el.innerHTML = ''; }
  },

  previewPrizeLogo(input, fid) {
    const file = input.files[0];
    if (!file) return;
    if (file.size > 500 * 1024) { this.toast('Imagen demasiado grande (máx 500KB)', 'error'); return; }
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const MAX_W = 800, MAX_H = 300;
        let w = img.width, h = img.height;
        if (w > MAX_W || h > MAX_H) {
          const ratio = Math.min(MAX_W / w, MAX_H / h);
          w = Math.round(w * ratio); h = Math.round(h * ratio);
        }
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        const dataUrl = canvas.toDataURL('image/png');
        if (dataUrl.length > 700 * 1024) {
          this.toast('La imagen sigue siendo muy pesada después de procesarla. Probá con un archivo más simple.', 'error');
          return;
        }
        const hidden = document.getElementById('prize-logo-data-' + fid);
        if (hidden) hidden.value = dataUrl;
        const preview = document.getElementById('prize-logo-preview-' + fid);
        if (preview) preview.innerHTML =
          '<img src="' + dataUrl + '" style="height:36px;max-width:130px;object-fit:contain;border-radius:6px;background:rgba(255,255,255,.04);padding:4px">' +
          '<div><button type="button" onclick="CHAdmin.clearPrizeLogo(\'' + fid + '\')" style="font-size:10px;color:var(--ca-red);background:none;border:none;cursor:pointer;margin-top:4px">✕ Quitar logo</button></div>';
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  },

  clearPrizeLogo(fid) {
    const hidden = document.getElementById('prize-logo-data-' + fid);
    if (hidden) hidden.value = '';
    const preview = document.getElementById('prize-logo-preview-' + fid);
    if (preview) preview.innerHTML = '<div style="font-size:10px;color:rgba(155,170,204,.3)">Sin logo</div>';
  },

  _readPrizeForm(fid) {
    const pts   = parseInt(document.getElementById('pf-pts-' + fid)?.value || '0', 10);
    const title = (document.getElementById('pf-title-' + fid)?.value || '').trim();
    const icon  = (document.getElementById('pf-icon-' + fid)?.value || '🏆').trim();
    const spName = (document.getElementById('pf-spname-' + fid)?.value || '').trim();
    const spUrl  = (document.getElementById('pf-spurl-' + fid)?.value || '').trim();
    const logo   = document.getElementById('prize-logo-data-' + fid)?.value || null;
    if (!pts || pts < 1) { this.toast('Ingresá los puntos del premio', 'error'); return null; }
    if (!title) { this.toast('Ingresá el título del premio', 'error'); return null; }
    return { pts, title, icon: icon || '🏆', sponsorName: spName || null, sponsorUrl: spUrl || null, sponsorLogo: logo || null };
  },

  async saveNewPrize() {
    const data = this._readPrizeForm('__new__');
    if (!data) return;
    data.id = 'p_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6);
    this._prizeLevels.push(data);
    this._prizeLevels.sort((a, b) => (a.pts || 0) - (b.pts || 0));
    if (!await this._savePrizeLevels()) return;
    this.cancelAddPrize();
    const cont = document.getElementById('cha-premios-content');
    if (cont) this._renderPremiosUI(cont);
  },

  async savePrize(id) {
    const data = this._readPrizeForm(id);
    if (!data) return;
    const idx = this._prizeLevels.findIndex(p => chaEsc(p.id) === id);
    if (idx === -1) { this.toast('Premio no encontrado', 'error'); return; }
    data.id = this._prizeLevels[idx].id;
    data.clicks = this._prizeLevels[idx].clicks || 0; // preservar el contador de clics existente
    this._prizeLevels[idx] = data;
    this._prizeLevels.sort((a, b) => (a.pts || 0) - (b.pts || 0));
    if (!await this._savePrizeLevels()) return;
    const cont = document.getElementById('cha-premios-content');
    if (cont) this._renderPremiosUI(cont);
  },

  async confirmDeletePrize(id) {
    const prize = this._prizeLevels.find(p => chaEsc(p.id) === id);
    if (!prize) return;
    if (!confirm('¿Eliminar el premio "' + (prize.title || 'este premio') + '"?')) return;
    this._prizeLevels = this._prizeLevels.filter(p => chaEsc(p.id) !== id);
    if (!await this._savePrizeLevels()) return;
    const cont = document.getElementById('cha-premios-content');
    if (cont) this._renderPremiosUI(cont);
  },

  async _savePrizeLevels() {
    try {
      await this.db.doc('config/prizes').set({ levels: this._prizeLevels }, { merge: true });
      this.toast('✅ Premio guardado', 'success');
      return true;
    } catch(e) {
      this.toast('Error al guardar premios', 'error');
      return false;
    }
  },

  /* ══════════════════════════════════════════════════
     TAB: PATROCINADORES — Título + Banner rotativo
     Colección champions_sponsors — un documento POR sponsor (no un array
     compartido en un solo doc, a diferencia de config/prizes) para que el
     límite de 1MiB de Firestore nunca dependa de cuántos sponsors haya.
  ══════════════════════════════════════════════════ */
  _sponsorLogoCache2: {},

  processSponsorLogo2(file, key, onReady) {
    if (!file) return;
    if (file.size > 500 * 1024) { this.toast('La imagen no debe superar 500KB', 'error'); return; }
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const maxW = 800, maxH = 300;
        const ratio = Math.min(maxW / img.width, maxH / img.height, 1);
        const w = Math.max(1, Math.round(img.width * ratio));
        const h = Math.max(1, Math.round(img.height * ratio));
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        const dataUrl = canvas.toDataURL('image/png');
        if (dataUrl.length > 700 * 1024) {
          this.toast('La imagen sigue siendo muy pesada después de procesarla. Probá con un archivo más simple.', 'error');
          return;
        }
        this._sponsorLogoCache2[key] = dataUrl;
        onReady(dataUrl);
      };
      img.onerror = () => this.toast('No se pudo leer la imagen', 'error');
      img.src = reader.result;
    };
    reader.onerror = () => this.toast('No se pudo leer el archivo', 'error');
    reader.readAsDataURL(file);
  },

  handleSponsorLogoInput2(e, key, previewId) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    this.processSponsorLogo2(file, key, dataUrl => {
      const img = document.getElementById(previewId);
      if (img) { img.src = dataUrl; img.style.display = 'inline-block'; }
    });
  },

  async renderPatrocinadores() {
    const cont = document.getElementById('cha-patrocinadores-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px">Cargando...</div>';
    try {
      const snap = await this.db.collection('champions_sponsors').get();
      const all = [];
      snap.forEach(d => all.push({ id: d.id, ...d.data() }));
      const title = all.find(s => s.tier === 'title') || null;
      const banners = all.filter(s => s.tier === 'banner').sort((a, b) => (a.order || 0) - (b.order || 0));

      let html = '<div style="font-size:11px;letter-spacing:2px;color:var(--ca-gold);font-weight:700;margin-bottom:6px">🏆 PATROCINADOR OFICIAL</div>' +
        '<p style="font-size:12px;color:var(--ca-muted);margin:0 0 12px">Banner destacado, máxima visibilidad, arriba del Dashboard.</p>' +
        this._sponsorTitleForm2(title) +
        '<div style="font-size:11px;letter-spacing:2px;color:var(--ca-gold);font-weight:700;margin:28px 0 6px">📢 BANNER ROTATIVO</div>' +
        '<p style="font-size:12px;color:var(--ca-muted);margin:0 0 12px">Franja de logos visible en Dashboard, Ranking, Premios, Mis Stats y Medallas.</p>' +
        this._sponsorBannerNewForm2() +
        (banners.length ? banners.map((s, i) => this._sponsorBannerRow2(s, i, banners.length)).join('')
          : '<p style="color:var(--ca-muted);font-size:12px;margin-top:8px">Aún no hay sponsors en el banner rotativo.</p>');

      cont.innerHTML = html;
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      cont.innerHTML = '<div style="color:var(--ca-red);padding:20px">Error al cargar patrocinadores.</div>';
    }
  },

  _sponsorTitleForm2(title) {
    const t = title || { name: '', url: '', logo: '' };
    return '<div class="cha-card">' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px">' +
        '<input class="cha-input" id="sp2-title-name" value="' + chaEsc(t.name || '') + '" placeholder="Nombre del patrocinador">' +
        '<input class="cha-input" id="sp2-title-url" type="url" value="' + chaEsc(t.url || '') + '" placeholder="https://sitio-del-sponsor.com">' +
      '</div>' +
      '<div style="display:flex;align-items:center;gap:10px;margin-bottom:12px">' +
        '<img id="sp2-title-preview" src="' + chaEsc(t.logo || '') + '" style="height:38px;max-width:140px;object-fit:contain;background:rgba(255,255,255,.06);border-radius:6px;padding:4px 8px;' + (t.logo ? '' : 'display:none;') + '">' +
        '<input type="file" accept="image/png,image/jpeg,image/webp" onchange="CHAdmin.handleSponsorLogoInput2(event,\'title\',\'sp2-title-preview\')" style="font-size:12px;color:var(--ca-muted);flex:1">' +
      '</div>' +
      '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">' +
        '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.saveSponsorTitle2()" style="padding:8px 18px;font-size:12px">💾 GUARDAR</button>' +
        '<button class="cha-btn" onclick="CHAdmin.previewSponsorTitle()" style="padding:8px 14px;font-size:12px">👁️ Vista previa</button>' +
        (title ? '<button class="cha-btn" onclick="CHAdmin.removeSponsorTitle2()" style="padding:8px 14px;font-size:12px;color:var(--ca-red);border-color:rgba(255,80,60,.3)">🗑️ Quitar</button>' : '') +
        (title ? '<span style="font-size:11px;color:var(--ca-muted);margin-left:auto">👆 ' + (title.clicks || 0) + ' clics</span>' : '') +
      '</div>' +
    '</div>';
  },

  async saveSponsorTitle2() {
    const name = document.getElementById('sp2-title-name')?.value.trim();
    const url  = document.getElementById('sp2-title-url')?.value.trim();
    if (!name) return this.toast('Ingresá el nombre del patrocinador', 'error');
    const preview = document.getElementById('sp2-title-preview');
    const logo = this._sponsorLogoCache2['title'] || (preview && preview.src.startsWith('data:') ? preview.src : '');
    try {
      const ref = this.db.doc('champions_sponsors/title');
      const existing = await ref.get();
      await ref.set({
        name, url, logo, tier: 'title', active: true,
        clicks: existing.exists ? (existing.data().clicks || 0) : 0,
        createdAt: existing.exists ? existing.data().createdAt : firebase.firestore.FieldValue.serverTimestamp()
      });
      delete this._sponsorLogoCache2['title'];
      this.toast('✅ Patrocinador Oficial guardado', 'success');
      this.renderPatrocinadores();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar.', 'error');
    }
  },

  async removeSponsorTitle2() {
    if (!confirm('¿Quitar el Patrocinador Oficial?')) return;
    try {
      await this.db.doc('champions_sponsors/title').delete();
      this.toast('Patrocinador Oficial eliminado', 'success');
      this.renderPatrocinadores();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al eliminar.', 'error');
    }
  },

  _sponsorBannerNewForm2() {
    return '<div class="cha-card" style="margin-bottom:10px;border-color:rgba(255,20,100,.3)">' +
      '<div style="font-size:11px;color:var(--ca-gold);letter-spacing:1px;margin-bottom:10px">+ AGREGAR SPONSOR AL BANNER</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px">' +
        '<input class="cha-input" id="sp2-new-name" placeholder="Nombre del patrocinador">' +
        '<input class="cha-input" id="sp2-new-url" type="url" placeholder="https://sitio-del-sponsor.com">' +
      '</div>' +
      '<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">' +
        '<img id="sp2-new-preview" src="" style="height:32px;max-width:100px;object-fit:contain;background:rgba(255,255,255,.06);border-radius:6px;display:none">' +
        '<input type="file" accept="image/png,image/jpeg,image/webp" onchange="CHAdmin.handleSponsorLogoInput2(event,\'banner-new\',\'sp2-new-preview\')" style="font-size:12px;color:var(--ca-muted);flex:1">' +
      '</div>' +
      '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.addBannerSponsor2()" style="padding:7px 16px;font-size:12px">+ Agregar</button> ' +
      '<button class="cha-btn" onclick="CHAdmin.previewSponsorBanner2(\'new\')" style="padding:7px 16px;font-size:12px">👁️ Vista previa</button>' +
    '</div>';
  },

  async addBannerSponsor2() {
    const name = document.getElementById('sp2-new-name')?.value.trim();
    const url  = document.getElementById('sp2-new-url')?.value.trim();
    if (!name) return this.toast('Ingresá el nombre del patrocinador', 'error');
    const logo = this._sponsorLogoCache2['banner-new'] || '';
    try {
      const existingSnap = await this.db.collection('champions_sponsors').where('tier', '==', 'banner').get();
      await this.db.collection('champions_sponsors').add({
        name, url, logo, tier: 'banner', active: true,
        order: existingSnap.size, clicks: 0, createdAt: firebase.firestore.FieldValue.serverTimestamp()
      });
      delete this._sponsorLogoCache2['banner-new'];
      this.toast('✅ Sponsor agregado al banner', 'success');
      this.renderPatrocinadores();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar.', 'error');
    }
  },

  _sponsorBannerRow2(s, idx, total) {
    const logoKey = 'banner-' + s.id;
    const previewId = 'sp2-banner-preview-' + s.id;
    return '<div class="cha-card" style="margin-bottom:10px;' + (s.active === false ? 'opacity:.5' : '') + '">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;gap:10px;flex-wrap:wrap">' +
        '<label style="display:flex;align-items:center;gap:8px;cursor:pointer;font-size:12px;color:var(--ca-muted)">' +
          '<input type="checkbox" ' + (s.active !== false ? 'checked' : '') + ' onchange="CHAdmin.toggleBannerActive2(\'' + s.id + '\',this.checked)"> Activo' +
        '</label>' +
        '<div style="display:flex;gap:6px;align-items:center">' +
          '<span style="font-size:11px;color:var(--ca-muted)">👆 ' + (s.clicks || 0) + ' clics</span>' +
          '<button onclick="CHAdmin.moveBannerSponsor2(\'' + s.id + '\',-1)" ' + (idx === 0 ? 'disabled' : '') + ' class="cha-btn" style="min-width:44px;min-height:44px;font-size:13px">↑</button>' +
          '<button onclick="CHAdmin.moveBannerSponsor2(\'' + s.id + '\',1)" ' + (idx === total - 1 ? 'disabled' : '') + ' class="cha-btn" style="min-width:44px;min-height:44px;font-size:13px">↓</button>' +
          '<button onclick="CHAdmin.removeBannerSponsor2(\'' + s.id + '\')" class="cha-btn" style="min-width:44px;min-height:44px;font-size:13px;color:var(--ca-red);border-color:rgba(255,80,60,.3)">🗑️</button>' +
        '</div>' +
      '</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px">' +
        '<input class="cha-input" id="sp2-name-' + s.id + '" value="' + chaEsc(s.name || '') + '" placeholder="Nombre">' +
        '<input class="cha-input" id="sp2-url-' + s.id + '" type="url" value="' + chaEsc(s.url || '') + '" placeholder="https://…">' +
      '</div>' +
      '<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">' +
        '<img id="' + previewId + '" src="' + chaEsc(s.logo || '') + '" style="height:28px;max-width:90px;object-fit:contain;background:rgba(255,255,255,.06);border-radius:6px;' + (s.logo ? '' : 'display:none;') + '">' +
        '<input type="file" accept="image/png,image/jpeg,image/webp" onchange="CHAdmin.handleSponsorLogoInput2(event,\'' + logoKey + '\',\'' + previewId + '\')" style="font-size:12px;color:var(--ca-muted);flex:1">' +
      '</div>' +
      '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.saveBannerSponsor2(\'' + s.id + '\')" style="padding:7px 16px;font-size:12px">💾 Guardar</button> ' +
      '<button class="cha-btn" onclick="CHAdmin.previewSponsorBanner2(\'' + s.id + '\')" style="padding:7px 16px;font-size:12px">👁️ Vista previa</button>' +
    '</div>';
  },

  async saveBannerSponsor2(id) {
    const name = document.getElementById('sp2-name-' + id)?.value.trim();
    const url  = document.getElementById('sp2-url-' + id)?.value.trim();
    if (!name) return this.toast('Ingresá el nombre del patrocinador', 'error');
    const logoKey = 'banner-' + id;
    const preview = document.getElementById('sp2-banner-preview-' + id);
    const logo = this._sponsorLogoCache2[logoKey] || (preview && preview.src.startsWith('data:') ? preview.src : '');
    try {
      await this.db.doc('champions_sponsors/' + id).update({ name, url, logo });
      delete this._sponsorLogoCache2[logoKey];
      this.toast('✅ Sponsor actualizado', 'success');
      this.renderPatrocinadores();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar.', 'error');
    }
  },

  async removeBannerSponsor2(id) {
    if (!confirm('¿Eliminar este sponsor del banner rotativo?')) return;
    try {
      await this.db.doc('champions_sponsors/' + id).delete();
      this.toast('Sponsor eliminado', 'success');
      this.renderPatrocinadores();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al eliminar.', 'error');
    }
  },

  async toggleBannerActive2(id, active) {
    try { await this.db.doc('champions_sponsors/' + id).update({ active }); }
    catch(e) { if (this.isSessionError(e)) return this.handleSessionErr(); this.toast('Error al guardar.', 'error'); }
  },

  async moveBannerSponsor2(id, direction) {
    try {
      const snap = await this.db.collection('champions_sponsors').where('tier', '==', 'banner').get();
      const banners = [];
      snap.forEach(d => banners.push({ id: d.id, ...d.data() }));
      banners.sort((a, b) => (a.order || 0) - (b.order || 0));
      const idx = banners.findIndex(b => b.id === id);
      const swapIdx = idx + direction;
      if (idx === -1 || swapIdx < 0 || swapIdx >= banners.length) return;
      const a = banners[idx], b = banners[swapIdx];
      const batch = this.db.batch();
      batch.update(this.db.doc('champions_sponsors/' + a.id), { order: b.order || 0 });
      batch.update(this.db.doc('champions_sponsors/' + b.id), { order: a.order || 0 });
      await batch.commit();
      this.renderPatrocinadores();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al reordenar.', 'error');
    }
  },

  /* ══════════════════════════════════════════════════
     TAB: BANNERS — carrusel de producto en el Dashboard
     Colección champions_banners — un doc por banner. "En vivo" = activo
     Y (sin fecha de inicio o ya pasó) Y (sin fecha de fin o no ha pasado
     todavía) — combina programación por fecha con control manual.
  ══════════════════════════════════════════════════ */
  _bannerImageCache: {},

  _isBannerLive(b) {
    if (b.active === false) return false;
    const now = Date.now();
    if (b.startAt && new Date(b.startAt).getTime() > now) return false;
    if (b.endAt && new Date(b.endAt).getTime() < now) return false;
    return true;
  },

  _fmtDateShort(iso) {
    try {
      const d = new Date(iso);
      const pad = n => String(n).padStart(2, '0');
      return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    } catch(e) { return iso; }
  },

  _bannerStatus(b) {
    if (b.active === false) return { text: '🚫 Desactivado manualmente', color: 'var(--ca-muted)' };
    const now = Date.now();
    if (b.startAt && new Date(b.startAt).getTime() > now) {
      return { text: '🕓 Programado — empieza ' + this._fmtDateShort(b.startAt), color: '#f59e0b' };
    }
    if (b.endAt && new Date(b.endAt).getTime() < now) {
      return { text: '⏸️ Finalizado — terminó ' + this._fmtDateShort(b.endAt), color: 'var(--ca-muted)' };
    }
    return { text: '🟢 En vivo ahora', color: '#4ade80' };
  },

  // Banners más grandes que un logo de sponsor — límites más generosos, pero
  // cada uno sigue siendo su propio documento, así que el margen de 1MiB de
  // Firestore nunca depende de cuántos banners haya en total.
  processBannerImage(file, key, onReady) {
    if (!file) return;
    if (file.size > 1.5 * 1024 * 1024) { this.toast('La imagen no debe superar 1.5MB', 'error'); return; }
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const maxW = 1400, maxH = 600;
        const ratio = Math.min(maxW / img.width, maxH / img.height, 1);
        const w = Math.max(1, Math.round(img.width * ratio));
        const h = Math.max(1, Math.round(img.height * ratio));
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        const dataUrl = canvas.toDataURL('image/jpeg', 0.88);
        if (dataUrl.length > 900 * 1024) {
          this.toast('La imagen sigue siendo muy pesada después de procesarla. Probá con un archivo más simple o más chico.', 'error');
          return;
        }
        this._bannerImageCache[key] = dataUrl;
        onReady(dataUrl);
      };
      img.onerror = () => this.toast('No se pudo leer la imagen', 'error');
      img.src = reader.result;
    };
    reader.onerror = () => this.toast('No se pudo leer el archivo', 'error');
    reader.readAsDataURL(file);
  },

  handleBannerImageInput(e, key, previewId) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    this.processBannerImage(file, key, dataUrl => {
      const img = document.getElementById(previewId);
      if (img) { img.src = dataUrl; img.style.display = 'block'; }
    });
  },

  async renderBanners() {
    const cont = document.getElementById('cha-banners-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ca-muted);padding:20px">Cargando...</div>';
    try {
      const snap = await this.db.collection('champions_banners').get();
      const banners = [];
      snap.forEach(d => banners.push({ id: d.id, ...d.data() }));
      banners.sort((a, b) => (a.order || 0) - (b.order || 0));

      let html = this._bannerNewForm() +
        (banners.length
          ? banners.map((b, i) => this._bannerRow(b, i, banners.length)).join('')
          : '<p style="color:var(--ca-muted);font-size:12px;margin-top:8px">Todavía no hay banners cargados.</p>');

      cont.innerHTML = html;
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      cont.innerHTML = '<div style="color:var(--ca-red);padding:20px">Error al cargar banners.</div>';
    }
  },

  /* ── Vista previa en vivo (banners/sponsors) ──────────
     sr-champions.css ya está cargado en esta misma página del admin, así que
     reutilizamos las clases reales del Dashboard — lo que se ve acá es
     pixel a pixel lo mismo que vería un usuario, antes de guardar nada. ── */
  _showLivePreviewModal(title, bodyHtml) {
    const existing = document.getElementById('cha-live-preview-modal');
    if (existing) existing.remove();
    const overlay = document.createElement('div');
    overlay.id = 'cha-live-preview-modal';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(5,6,10,.85);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px';
    overlay.innerHTML =
      '<div style="background:#0b0d12;border:1px solid rgba(255,255,255,.15);border-radius:16px;padding:24px;max-width:560px;width:100%;max-height:88vh;overflow-y:auto">' +
        '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px">' +
          '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:16px;letter-spacing:1px;color:#FF1464">' + chaEsc(title) + '</span>' +
          '<button onclick="document.getElementById(\'cha-live-preview-modal\').remove()" style="background:none;border:none;color:#9aaabf;font-size:18px;cursor:pointer;line-height:1">✕</button>' +
        '</div>' +
        bodyHtml +
        '<div style="margin-top:16px;font-size:11px;color:#4e5f7a;text-align:center">Así se va a ver en el Dashboard real — todavía no guardaste estos cambios.</div>' +
      '</div>';
    overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });
    document.body.appendChild(overlay);
  },

  previewBanner(key) {
    const isNew = key === 'new';
    const previewImgId = isNew ? 'bn-new-preview' : ('bn-preview-' + key);
    const cacheKey = isNew ? 'new' : ('edit-' + key);
    const image = this._bannerImageCache[cacheKey] || document.getElementById(previewImgId)?.getAttribute('src') || '';
    if (!image) return this.toast('Subí una imagen primero para poder previsualizarla', 'error');
    const title   = document.getElementById(isNew ? 'bn-new-title' : 'bn-title-' + key)?.value.trim() || '';
    const ctaText = document.getElementById(isNew ? 'bn-new-cta'   : 'bn-cta-'   + key)?.value.trim() || '';
    const overlay = (title || ctaText)
      ? '<div class="sr-ch-banner-overlay">' +
          (title ? '<div class="sr-ch-banner-title">' + chaEsc(title) + '</div>' : '') +
          (ctaText ? '<span class="sr-ch-banner-cta">' + chaEsc(ctaText) + '</span>' : '') +
        '</div>'
      : '';
    this._showLivePreviewModal('🖼️ Vista previa del banner',
      '<div class="sr-ch-banner-carousel" style="max-width:480px;margin:0 auto">' +
        '<div class="sr-ch-banner-track"><div class="sr-ch-banner-slide"><img class="sr-ch-banner-img" src="' + image + '">' + overlay + '</div></div>' +
      '</div>'
    );
  },

  previewSponsorTitle() {
    const name = document.getElementById('sp2-title-name')?.value.trim() || '';
    const preview = document.getElementById('sp2-title-preview');
    const logo = this._sponsorLogoCache2['title'] || (preview && preview.style.display !== 'none' ? preview.getAttribute('src') : '');
    if (!name && !logo) return this.toast('Completá el nombre o subí un logo para previsualizar', 'error');
    const inner = logo
      ? '<img class="sr-ch-sponsor-title-logo" src="' + logo + '">'
      : '<span class="sr-ch-sponsor-title-name">' + chaEsc(name) + '</span>';
    this._showLivePreviewModal('📢 Vista previa — Patrocinador Oficial',
      '<div class="sr-ch-sponsor-title" style="max-width:420px;margin:0 auto">' +
        '<span class="sr-ch-sponsor-title-label">PRESENTADO POR</span>' + inner +
      '</div>'
    );
  },

  previewSponsorBanner2(id) {
    const isNew = id === 'new';
    const previewId = isNew ? 'sp2-new-preview' : ('sp2-banner-preview-' + id);
    const cacheKey = isNew ? 'banner-new' : ('banner-' + id);
    const name = document.getElementById(isNew ? 'sp2-new-name' : 'sp2-name-' + id)?.value.trim() || '';
    const preview = document.getElementById(previewId);
    const logo = this._sponsorLogoCache2[cacheKey] || (preview && preview.style.display !== 'none' ? preview.getAttribute('src') : '');
    if (!name && !logo) return this.toast('Completá el nombre o subí un logo para previsualizar', 'error');
    const inner = logo
      ? '<img class="sr-ch-sponsor-item-logo" src="' + logo + '">'
      : '<span class="sr-ch-sponsor-item-name">' + chaEsc(name) + '</span>';
    this._showLivePreviewModal('📢 Vista previa — Banner rotativo de sponsors',
      '<div class="sr-ch-sponsor-strip" style="max-width:420px;margin:0 auto">' +
        '<div class="sr-ch-sponsor-page active"><div class="sr-ch-sponsor-item">' + inner + '</div></div>' +
      '</div>'
    );
  },

  _bannerNewForm() {
    return '<div class="cha-card" style="margin-bottom:16px;border-color:rgba(255,20,100,.3)">' +
      '<div style="font-size:11px;color:var(--ca-gold);letter-spacing:1px;margin-bottom:12px">+ AGREGAR BANNER</div>' +
      '<div style="margin-bottom:10px">' +
        '<label class="cha-label">Imagen (recomendado horizontal, ej. 1200×500 · máx 1.5MB)</label>' +
        '<img id="bn-new-preview" src="" style="display:none;max-width:280px;max-height:120px;object-fit:contain;border-radius:8px;margin-bottom:8px;background:rgba(255,255,255,.04)">' +
        '<input type="file" accept="image/png,image/jpeg,image/webp" onchange="CHAdmin.handleBannerImageInput(event,\'new\',\'bn-new-preview\')" class="cha-input" style="padding:8px;font-size:12px">' +
      '</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px">' +
        '<div><label class="cha-label">Texto superpuesto (opcional)</label><input class="cha-input" id="bn-new-title" placeholder="Ej: 20% OFF Camisola Oficial"></div>' +
        '<div><label class="cha-label">Texto del botón (opcional)</label><input class="cha-input" id="bn-new-cta" placeholder="Ej: Ver más"></div>' +
      '</div>' +
      '<div style="margin-bottom:10px">' +
        '<label class="cha-label">Link (opcional — a dónde lleva al hacer clic)</label>' +
        '<input class="cha-input" id="bn-new-link" type="url" placeholder="https://tutienda.com/products/...">' +
      '</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:12px">' +
        '<div><label class="cha-label">🕓 Empieza (opcional)</label><input class="cha-input" type="datetime-local" id="bn-new-start"></div>' +
        '<div><label class="cha-label">🕓 Termina (opcional)</label><input class="cha-input" type="datetime-local" id="bn-new-end"></div>' +
      '</div>' +
      '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.addBanner()" style="padding:8px 18px;font-size:12px">+ Agregar</button> ' +
      '<button class="cha-btn" onclick="CHAdmin.previewBanner(\'new\')" style="padding:8px 18px;font-size:12px">👁️ Vista previa</button>' +
    '</div>';
  },

  async addBanner() {
    const image = this._bannerImageCache['new'];
    if (!image) return this.toast('Subí una imagen para el banner', 'error');
    const title   = document.getElementById('bn-new-title')?.value.trim() || null;
    const ctaText = document.getElementById('bn-new-cta')?.value.trim() || null;
    const link    = document.getElementById('bn-new-link')?.value.trim() || null;
    const startEl = document.getElementById('bn-new-start')?.value;
    const endEl   = document.getElementById('bn-new-end')?.value;
    const startAt = startEl ? new Date(startEl).toISOString() : null;
    const endAt   = endEl ? new Date(endEl).toISOString() : null;
    if (startAt && endAt && new Date(startAt) >= new Date(endAt)) {
      return this.toast('La fecha de fin debe ser después de la de inicio', 'error');
    }
    try {
      const existingSnap = await this.db.collection('champions_banners').get();
      await this.db.collection('champions_banners').add({
        image, title, ctaText, link, startAt, endAt, active: true,
        order: existingSnap.size, clicks: 0, createdAt: firebase.firestore.FieldValue.serverTimestamp()
      });
      delete this._bannerImageCache['new'];
      this.toast('✅ Banner agregado', 'success');
      this.renderBanners();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar.', 'error');
    }
  },

  _bannerRow(b, idx, total) {
    const imgKey = 'edit-' + b.id;
    const previewId = 'bn-preview-' + b.id;
    const status = this._bannerStatus(b);
    return '<div class="cha-card" style="margin-bottom:12px;' + (b.active === false ? 'opacity:.55' : '') + '">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;gap:10px;flex-wrap:wrap">' +
        '<span style="font-size:11px;font-weight:700;color:' + status.color + '">' + status.text + '</span>' +
        '<div style="display:flex;gap:6px;align-items:center">' +
          '<label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:11px;color:var(--ca-muted)">' +
            '<input type="checkbox" ' + (b.active !== false ? 'checked' : '') + ' onchange="CHAdmin.toggleBannerActiveState(\'' + b.id + '\',this.checked)"> Activo' +
          '</label>' +
          '<span style="font-size:11px;color:var(--ca-muted)">👆 ' + (b.clicks || 0) + ' clics</span>' +
          '<button onclick="CHAdmin.moveBanner(\'' + b.id + '\',-1)" ' + (idx === 0 ? 'disabled' : '') + ' class="cha-btn" style="min-width:44px;min-height:44px;font-size:13px">↑</button>' +
          '<button onclick="CHAdmin.moveBanner(\'' + b.id + '\',1)" ' + (idx === total - 1 ? 'disabled' : '') + ' class="cha-btn" style="min-width:44px;min-height:44px;font-size:13px">↓</button>' +
          '<button onclick="CHAdmin.removeBanner(\'' + b.id + '\')" class="cha-btn" style="min-width:44px;min-height:44px;font-size:13px;color:var(--ca-red);border-color:rgba(255,80,60,.3)">🗑️</button>' +
        '</div>' +
      '</div>' +
      '<img id="' + previewId + '" src="' + chaEsc(b.image || '') + '" style="max-width:280px;max-height:120px;object-fit:contain;border-radius:8px;margin-bottom:10px;background:rgba(255,255,255,.04);display:block">' +
      '<input type="file" accept="image/png,image/jpeg,image/webp" onchange="CHAdmin.handleBannerImageInput(event,\'' + imgKey + '\',\'' + previewId + '\')" class="cha-input" style="padding:8px;font-size:12px;margin-bottom:10px">' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px">' +
        '<div><label class="cha-label">Texto superpuesto</label><input class="cha-input" id="bn-title-' + b.id + '" value="' + chaEsc(b.title || '') + '"></div>' +
        '<div><label class="cha-label">Texto del botón</label><input class="cha-input" id="bn-cta-' + b.id + '" value="' + chaEsc(b.ctaText || '') + '"></div>' +
      '</div>' +
      '<div style="margin-bottom:10px"><label class="cha-label">Link</label><input class="cha-input" id="bn-link-' + b.id + '" type="url" value="' + chaEsc(b.link || '') + '"></div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:12px">' +
        '<div><label class="cha-label">🕓 Empieza</label><input class="cha-input" type="datetime-local" id="bn-start-' + b.id + '" value="' + this.toLocalInputValue(b.startAt || '') + '"></div>' +
        '<div><label class="cha-label">🕓 Termina</label><input class="cha-input" type="datetime-local" id="bn-end-' + b.id + '" value="' + this.toLocalInputValue(b.endAt || '') + '"></div>' +
      '</div>' +
      '<button class="cha-btn cha-btn-gold" onclick="CHAdmin.saveBanner(\'' + b.id + '\')" style="padding:7px 16px;font-size:12px">💾 Guardar</button> ' +
      '<button class="cha-btn" onclick="CHAdmin.previewBanner(\'' + b.id + '\')" style="padding:7px 16px;font-size:12px">👁️ Vista previa</button>' +
    '</div>';
  },

  async saveBanner(id) {
    const title   = document.getElementById('bn-title-' + id)?.value.trim() || null;
    const ctaText = document.getElementById('bn-cta-' + id)?.value.trim() || null;
    const link    = document.getElementById('bn-link-' + id)?.value.trim() || null;
    const startEl = document.getElementById('bn-start-' + id)?.value;
    const endEl   = document.getElementById('bn-end-' + id)?.value;
    const startAt = startEl ? new Date(startEl).toISOString() : null;
    const endAt   = endEl ? new Date(endEl).toISOString() : null;
    if (startAt && endAt && new Date(startAt) >= new Date(endAt)) {
      return this.toast('La fecha de fin debe ser después de la de inicio', 'error');
    }
    const imgKey = 'edit-' + id;
    const preview = document.getElementById('bn-preview-' + id);
    const image = this._bannerImageCache[imgKey] || (preview && preview.src);
    try {
      const FVD = firebase.firestore.FieldValue.delete();
      await this.db.doc('champions_banners/' + id).update({
        title, ctaText, link, image,
        startAt: startAt || FVD, endAt: endAt || FVD
      });
      delete this._bannerImageCache[imgKey];
      this.toast('✅ Banner actualizado', 'success');
      this.renderBanners();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al guardar.', 'error');
    }
  },

  async removeBanner(id) {
    if (!confirm('¿Eliminar este banner del carrusel?')) return;
    try {
      await this.db.doc('champions_banners/' + id).delete();
      this.toast('Banner eliminado', 'success');
      this.renderBanners();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al eliminar.', 'error');
    }
  },

  async toggleBannerActiveState(id, active) {
    try { await this.db.doc('champions_banners/' + id).update({ active }); this.renderBanners(); }
    catch(e) { if (this.isSessionError(e)) return this.handleSessionErr(); this.toast('Error al guardar.', 'error'); }
  },

  async moveBanner(id, direction) {
    try {
      const snap = await this.db.collection('champions_banners').get();
      const banners = [];
      snap.forEach(d => banners.push({ id: d.id, ...d.data() }));
      banners.sort((a, b) => (a.order || 0) - (b.order || 0));
      const idx = banners.findIndex(b => b.id === id);
      const swapIdx = idx + direction;
      if (idx === -1 || swapIdx < 0 || swapIdx >= banners.length) return;
      const a = banners[idx], b = banners[swapIdx];
      const batch = this.db.batch();
      batch.update(this.db.doc('champions_banners/' + a.id), { order: b.order || 0 });
      batch.update(this.db.doc('champions_banners/' + b.id), { order: a.order || 0 });
      await batch.commit();
      this.renderBanners();
    } catch(e) {
      if (this.isSessionError(e)) return this.handleSessionErr();
      this.toast('Error al reordenar.', 'error');
    }
  }
};

/* ── Iniciar ──────────────────────────────────────── */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => CHAdmin.init());
} else {
  CHAdmin.init();
}
